function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/** Listing identity: one row per block inclusion of a list-asset transaction. */
var LISTINGS_INCLUSION_INDEX = 'listings_signature_block_hash_uidx';
var LISTINGS_MIGRATION_TABLE = 'listings_inclusion_migration';
/** Order identity: one row per block inclusion of a purchase transaction. */
var ORDERS_INCLUSION_INDEX = 'orders_order_tx_sig_block_hash_uidx';
var ORDERS_PAYMENT_INCLUSION_INDEX = 'orders_payment_utxo_block_hash_uidx';
var _require = require('./categories'),
  STORE_CATEGORIES = _require.STORE_CATEGORIES;

// Shared across Database instances using the same SQLite connection.
var transactionTails = new WeakMap();
function quoteIdentifier(identifier) {
  return "\"".concat(String(identifier).replace(/"/g, '""'), "\"");
}

/** Quote only when needed, so a rebuilt table's stored DDL matches the definition. */
function columnIdentifier(name) {
  return /^[A-Za-z_][A-Za-z0-9_]*$/.test(String(name)) ? String(name) : quoteIdentifier(name);
}
var Database = /*#__PURE__*/function () {
  function Database(app, mod) {
    _classCallCheck(this, Database);
    this.app = app;
    this.mod = mod;
  }
  return _createClass(Database, [{
    key: "dbname",
    get: function get() {
      return this.mod.dbname;
    }
  }, {
    key: "ensureSchema",
    value: function () {
      var _ensureSchema = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var listing_columns, summary_columns, order_columns, _i, _arr, sql, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              listing_columns = ['ALTER TABLE listings ADD COLUMN in_flight INTEGER NOT NULL DEFAULT 0', 'ALTER TABLE listings ADD COLUMN reserved_order_id INTEGER NOT NULL DEFAULT 0', 'ALTER TABLE listings ADD COLUMN block_id_listed INTEGER NOT NULL DEFAULT 0', 'ALTER TABLE listings ADD COLUMN block_hash_listed TEXT NOT NULL DEFAULT ""', 'ALTER TABLE listings ADD COLUMN transaction_id_listed INTEGER NOT NULL DEFAULT 0', 'ALTER TABLE listings ADD COLUMN longest_chain_listed INTEGER NOT NULL DEFAULT 1', 'ALTER TABLE listings ADD COLUMN block_id_sold INTEGER NOT NULL DEFAULT 0', 'ALTER TABLE listings ADD COLUMN block_hash_sold TEXT NOT NULL DEFAULT ""', 'ALTER TABLE listings ADD COLUMN transaction_id_sold INTEGER NOT NULL DEFAULT 0', 'ALTER TABLE listings ADD COLUMN longest_chain_sold INTEGER NOT NULL DEFAULT 0', 'ALTER TABLE listings ADD COLUMN settlement_pending INTEGER NOT NULL DEFAULT 0', 'ALTER TABLE listings ADD COLUMN category TEXT DEFAULT "Other"', 'ALTER TABLE listings ADD COLUMN note TEXT NOT NULL DEFAULT ""', 'ALTER TABLE listings ADD COLUMN buyer TEXT NOT NULL DEFAULT ""', 'ALTER TABLE listings ADD COLUMN quantity_sold INTEGER NOT NULL DEFAULT 0', 'ALTER TABLE listings ADD COLUMN sold_at INTEGER NOT NULL DEFAULT 0', 'ALTER TABLE listings ADD COLUMN approved INTEGER NOT NULL DEFAULT 0', 'ALTER TABLE listings ADD COLUMN risk TEXT NOT NULL DEFAULT ""', 'ALTER TABLE listings ADD COLUMN web3_ticker TEXT NOT NULL DEFAULT ""', 'ALTER TABLE listings ADD COLUMN web3_amount TEXT NOT NULL DEFAULT ""'];
              summary_columns = ['ALTER TABLE summary ADD COLUMN category TEXT DEFAULT "Other"', 'ALTER TABLE summary ADD COLUMN web3_ticker TEXT NOT NULL DEFAULT ""', 'ALTER TABLE summary ADD COLUMN web3_amount TEXT NOT NULL DEFAULT ""'];
              order_columns = ['ALTER TABLE orders ADD COLUMN quantity INTEGER NOT NULL DEFAULT 1', 'ALTER TABLE orders ADD COLUMN payment_utxo_slip TEXT NOT NULL DEFAULT ""', 'ALTER TABLE orders ADD COLUMN payment_access_hash TEXT NOT NULL DEFAULT ""', 'ALTER TABLE orders ADD COLUMN payment_access_script TEXT NOT NULL DEFAULT ""', 'ALTER TABLE orders ADD COLUMN payment_p2sh_address TEXT NOT NULL DEFAULT ""', 'ALTER TABLE orders ADD COLUMN attempts INTEGER NOT NULL DEFAULT 0', 'ALTER TABLE orders ADD COLUMN status TEXT NOT NULL DEFAULT "pending"', 'ALTER TABLE orders ADD COLUMN block_id_received INTEGER NOT NULL DEFAULT 0', 'ALTER TABLE orders ADD COLUMN block_hash_received TEXT NOT NULL DEFAULT ""', 'ALTER TABLE orders ADD COLUMN transaction_id_received INTEGER NOT NULL DEFAULT 0', 'ALTER TABLE orders ADD COLUMN longest_chain_received INTEGER NOT NULL DEFAULT 1', 'ALTER TABLE orders ADD COLUMN note TEXT NOT NULL DEFAULT ""'];
              _i = 0, _arr = [].concat(listing_columns, summary_columns, order_columns);
            case 1:
              if (!(_i < _arr.length)) {
                _context.n = 6;
                break;
              }
              sql = _arr[_i];
              _context.p = 2;
              _context.n = 3;
              return this.app.storage.runDatabase(sql, {}, this.dbname);
            case 3:
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
            case 5:
              _i++;
              _context.n = 1;
              break;
            case 6:
              _context.n = 7;
              return this.migrateListingChainFields();
            case 7:
              _context.n = 8;
              return this.migrateListingInclusionUniqueness();
            case 8:
              _context.n = 9;
              return this.ensureListingSales();
            case 9:
              _context.n = 10;
              return this.migrateOrderChainFields();
            case 10:
              _context.n = 11;
              return this.migrateOrderCryptoFieldNames();
            case 11:
              _context.n = 12;
              return this.migrateOrderInclusionUniqueness();
            case 12:
              return _context.a(2);
          }
        }, _callee, this, [[2, 4]]);
      }));
      function ensureSchema() {
        return _ensureSchema.apply(this, arguments);
      }
      return ensureSchema;
    }()
    /**
     * Sale inclusions: one row per (listing inclusion, fulfillment block).
     * Backfill from listing rows that still have a real sale hash. Rows whose
     * sale identity was wiped to empty are not guessed here. A later confirmation
     * or wind recovery rebuilds them by matching fulfillment inputs to slips.
     * block_id_sold = -1 was the local pending sentinel, not a block.
     */
  }, {
    key: "ensureListingSales",
    value: function () {
      var _ensureListingSales = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var db, statements, _iterator, _step, _sql, sale_columns, _i2, _sale_columns, sql, _t2, _t3;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.n = 1;
              return this.app.storage.returnDatabaseByName(this.dbname);
            case 1:
              db = _context2.v;
              if (db) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              statements = this.returnSchemaStatements('listing_sales.sql');
              _iterator = _createForOfIteratorHelper(statements);
              _context2.p = 3;
              _iterator.s();
            case 4:
              if ((_step = _iterator.n()).done) {
                _context2.n = 6;
                break;
              }
              _sql = _step.value;
              _context2.n = 5;
              return db.exec(_sql);
            case 5:
              _context2.n = 4;
              break;
            case 6:
              _context2.n = 8;
              break;
            case 7:
              _context2.p = 7;
              _t2 = _context2.v;
              _iterator.e(_t2);
            case 8:
              _context2.p = 8;
              _iterator.f();
              return _context2.f(8);
            case 9:
              sale_columns = ['ALTER TABLE listing_sales ADD COLUMN seller TEXT NOT NULL DEFAULT ""', 'ALTER TABLE listing_sales ADD COLUMN web3_ticker TEXT NOT NULL DEFAULT ""', 'ALTER TABLE listing_sales ADD COLUMN web3_amount TEXT NOT NULL DEFAULT ""', 'ALTER TABLE listing_sales ADD COLUMN web3_payment_withdrawal_processed INTEGER NOT NULL DEFAULT 0', 'ALTER TABLE listing_sales ADD COLUMN web3_payment_withdrawal_address TEXT NOT NULL DEFAULT ""', 'ALTER TABLE listing_sales ADD COLUMN web3_payment_withdrawal_publickey TEXT NOT NULL DEFAULT ""', 'ALTER TABLE listing_sales ADD COLUMN web3_payment_withdrawal_request TEXT NOT NULL DEFAULT ""', 'ALTER TABLE listing_sales ADD COLUMN web3_payment_withdrawal_created_at INTEGER NOT NULL DEFAULT 0', 'ALTER TABLE listing_sales ADD COLUMN web3_payment_withdrawal_mixin_uuid TEXT NOT NULL DEFAULT ""'];
              _i2 = 0, _sale_columns = sale_columns;
            case 10:
              if (!(_i2 < _sale_columns.length)) {
                _context2.n = 15;
                break;
              }
              sql = _sale_columns[_i2];
              _context2.p = 11;
              _context2.n = 12;
              return db.exec(sql);
            case 12:
              _context2.n = 14;
              break;
            case 13:
              _context2.p = 13;
              _t3 = _context2.v;
            case 14:
              _i2++;
              _context2.n = 10;
              break;
            case 15:
              _context2.n = 16;
              return db.exec("INSERT OR IGNORE INTO listing_sales (\n\t\t\t\t  signature, block_hash_listed,\n\t\t\t\t  block_id_sold, block_hash_sold, transaction_id_sold, longest_chain_sold,\n\t\t\t\t  buyer, note, quantity_sold, sold_at, created_at, updated_at\n\t\t\t\t)\n\t\t\t\tSELECT signature, block_hash_listed,\n\t\t\t\t       block_id_sold, block_hash_sold, transaction_id_sold, longest_chain_sold,\n\t\t\t\t       buyer, note, quantity_sold, sold_at, created_at, updated_at\n\t\t\t\t  FROM listings\n\t\t\t\t WHERE block_id_sold > 0 AND block_hash_sold != ''");
            case 16:
              _context2.n = 17;
              return db.run("UPDATE listings\n\t\t\t\t  SET settlement_pending = 1,\n\t\t\t\t      block_id_sold = 0,\n\t\t\t\t      longest_chain_sold = 0,\n\t\t\t\t      updated_at = $updated_at\n\t\t\t\tWHERE block_id_sold = -1", {
                $updated_at: Date.now()
              });
            case 17:
              return _context2.a(2);
          }
        }, _callee2, this, [[11, 13], [3, 7, 8, 9]]);
      }));
      function ensureListingSales() {
        return _ensureListingSales.apply(this, arguments);
      }
      return ensureListingSales;
    }()
  }, {
    key: "returnSchemaStatements",
    value: function returnSchemaStatements(filename) {
      var fs = this.app.storage.returnFileSystem();
      if (!(fs !== null && fs !== void 0 && fs.readFileSync)) {
        throw new Error('filesystem unavailable');
      }
      return fs.readFileSync("".concat(__dirname, "/../sql/").concat(filename), 'utf8').split(';').map(function (statement) {
        return statement.replace(/^(?:\s*--[^\n]*)+/, '').trim();
      }).filter(Boolean);
    }

    /**
     * Move live databases from order identity by signature alone to identity by
     * (order_tx_sig, block_hash_received). Both legacy constraints are standalone
     * indexes rather than inline column constraints, so they can be dropped in place
     * without rebuilding the table. Existing rows hold at most one inclusion per
     * signature, so the copy cannot violate either composite key.
     */
  }, {
    key: "migrateOrderInclusionUniqueness",
    value: function () {
      var _migrateOrderInclusionUniqueness = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var db, legacy, _iterator2, _step2, index, _t4, _t5, _t6, _t7;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.n = 1;
              return this.app.storage.returnDatabaseByName(this.dbname);
            case 1:
              db = _context3.v;
              if (db) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2);
            case 2:
              _context3.p = 2;
              _context3.n = 3;
              return this.returnLegacyOrderIndexes(db);
            case 3:
              legacy = _context3.v;
              _context3.n = 4;
              return db.exec('BEGIN IMMEDIATE');
            case 4:
              _context3.p = 4;
              _iterator2 = _createForOfIteratorHelper(legacy);
              _context3.p = 5;
              _iterator2.s();
            case 6:
              if ((_step2 = _iterator2.n()).done) {
                _context3.n = 8;
                break;
              }
              index = _step2.value;
              _context3.n = 7;
              return db.exec("DROP INDEX ".concat(quoteIdentifier(index.name)));
            case 7:
              _context3.n = 6;
              break;
            case 8:
              _context3.n = 10;
              break;
            case 9:
              _context3.p = 9;
              _t4 = _context3.v;
              _iterator2.e(_t4);
            case 10:
              _context3.p = 10;
              _iterator2.f();
              return _context3.f(10);
            case 11:
              _context3.n = 12;
              return db.exec("CREATE UNIQUE INDEX IF NOT EXISTS ".concat(quoteIdentifier(ORDERS_INCLUSION_INDEX), "\n\t\t\t\t\t ON orders (order_tx_sig, block_hash_received)"));
            case 12:
              _context3.n = 13;
              return db.exec("CREATE UNIQUE INDEX IF NOT EXISTS ".concat(quoteIdentifier(ORDERS_PAYMENT_INCLUSION_INDEX), "\n\t\t\t\t\t ON orders (payment_tx_sig, payment_output_index, block_hash_received)"));
            case 13:
              _context3.n = 14;
              return db.exec('COMMIT');
            case 14:
              _context3.n = 20;
              break;
            case 15:
              _context3.p = 15;
              _t5 = _context3.v;
              _context3.p = 16;
              _context3.n = 17;
              return db.exec('ROLLBACK');
            case 17:
              _context3.n = 19;
              break;
            case 18:
              _context3.p = 18;
              _t6 = _context3.v;
            case 19:
              throw _t5;
            case 20:
              _context3.n = 22;
              break;
            case 21:
              _context3.p = 21;
              _t7 = _context3.v;
              // Leaving the legacy constraints in place keeps the pre-inclusion behaviour
              // (a re-included purchase tx is ignored) rather than stopping the module.
              console.error('Store Database: orders inclusion migration failed', (_t7 === null || _t7 === void 0 ? void 0 : _t7.message) || _t7);
            case 22:
              return _context3.a(2);
          }
        }, _callee3, this, [[16, 18], [5, 9, 10, 11], [4, 15], [2, 21]]);
      }));
      function migrateOrderInclusionUniqueness() {
        return _migrateOrderInclusionUniqueness.apply(this, arguments);
      }
      return migrateOrderInclusionUniqueness;
    }()
    /**
     * Unique order indexes that predate inclusion identity, matched on their columns so
     * a renamed index is still found. Anything already carrying block_hash_received is
     * left alone, which makes the migration idempotent.
     */
  }, {
    key: "returnLegacyOrderIndexes",
    value: function () {
      var _returnLegacyOrderIndexes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(db) {
        var legacy_shapes, indexes, found, _iterator3, _step3, _loop, _t8;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              legacy_shapes = [['order_tx_sig'], ['payment_tx_sig', 'payment_output_index']];
              _context5.n = 1;
              return db.all("PRAGMA index_list('orders')");
            case 1:
              indexes = _context5.v;
              found = [];
              _iterator3 = _createForOfIteratorHelper(indexes || []);
              _context5.p = 2;
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var index, columns, names, is_legacy;
                return _regenerator().w(function (_context4) {
                  while (1) switch (_context4.n) {
                    case 0:
                      index = _step3.value;
                      if (Number(index.unique)) {
                        _context4.n = 1;
                        break;
                      }
                      return _context4.a(2, 1);
                    case 1:
                      _context4.n = 2;
                      return db.all("PRAGMA index_info(".concat(quoteIdentifier(index.name), ")"));
                    case 2:
                      columns = _context4.v;
                      names = (columns || []).map(function (column) {
                        return column.name;
                      });
                      is_legacy = legacy_shapes.some(function (shape) {
                        return shape.length === names.length && shape.every(function (column, i) {
                          return column === names[i];
                        });
                      });
                      if (is_legacy) {
                        found.push(index);
                      }
                    case 3:
                      return _context4.a(2);
                  }
                }, _loop);
              });
              _iterator3.s();
            case 3:
              if ((_step3 = _iterator3.n()).done) {
                _context5.n = 6;
                break;
              }
              return _context5.d(_regeneratorValues(_loop()), 4);
            case 4:
              if (!_context5.v) {
                _context5.n = 5;
                break;
              }
              return _context5.a(3, 5);
            case 5:
              _context5.n = 3;
              break;
            case 6:
              _context5.n = 8;
              break;
            case 7:
              _context5.p = 7;
              _t8 = _context5.v;
              _iterator3.e(_t8);
            case 8:
              _context5.p = 8;
              _iterator3.f();
              return _context5.f(8);
            case 9:
              return _context5.a(2, found);
          }
        }, _callee4, null, [[2, 7, 8, 9]]);
      }));
      function returnLegacyOrderIndexes(_x) {
        return _returnLegacyOrderIndexes.apply(this, arguments);
      }
      return returnLegacyOrderIndexes;
    }()
    /**
     * Move live databases from UNIQUE(signature) to UNIQUE(signature, block_hash_listed).
     * SQLite cannot drop an inline column constraint, so a legacy table is rebuilt in
     * place. Existing rows hold at most one inclusion per signature, so the copy cannot
     * violate the composite key.
     */
  }, {
    key: "migrateListingInclusionUniqueness",
    value: function () {
      var _migrateListingInclusionUniqueness = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var db, legacy, _t9;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.n = 1;
              return this.app.storage.returnDatabaseByName(this.dbname);
            case 1:
              db = _context6.v;
              if (db) {
                _context6.n = 2;
                break;
              }
              return _context6.a(2);
            case 2:
              _context6.p = 2;
              _context6.n = 3;
              return this.returnLegacySignatureIndex(db);
            case 3:
              legacy = _context6.v;
              if (!(legacy && legacy.origin === 'c')) {
                _context6.n = 5;
                break;
              }
              _context6.n = 4;
              return db.exec("DROP INDEX ".concat(quoteIdentifier(legacy.name)));
            case 4:
              _context6.n = 6;
              break;
            case 5:
              if (!legacy) {
                _context6.n = 6;
                break;
              }
              _context6.n = 6;
              return this.rebuildListingsWithoutSignatureUnique(db);
            case 6:
              _context6.n = 7;
              return db.exec("CREATE UNIQUE INDEX IF NOT EXISTS ".concat(quoteIdentifier(LISTINGS_INCLUSION_INDEX), "\n\t\t\t\t ON listings (signature, block_hash_listed)"));
            case 7:
              _context6.n = 9;
              break;
            case 8:
              _context6.p = 8;
              _t9 = _context6.v;
              // Leaving the legacy constraint in place keeps the pre-inclusion behaviour
              // (a re-included listing tx is ignored) rather than stopping the module.
              console.error('Store Database: listings inclusion migration failed', (_t9 === null || _t9 === void 0 ? void 0 : _t9.message) || _t9);
            case 9:
              return _context6.a(2);
          }
        }, _callee5, this, [[2, 8]]);
      }));
      function migrateListingInclusionUniqueness() {
        return _migrateListingInclusionUniqueness.apply(this, arguments);
      }
      return migrateListingInclusionUniqueness;
    }() /** The unique index enforcing signature-only listing identity, if one still exists. */
  }, {
    key: "returnLegacySignatureIndex",
    value: function () {
      var _returnLegacySignatureIndex = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(db) {
        var indexes, _iterator4, _step4, index, columns, _t0;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.n = 1;
              return db.all("PRAGMA index_list('listings')");
            case 1:
              indexes = _context7.v;
              _iterator4 = _createForOfIteratorHelper(indexes || []);
              _context7.p = 2;
              _iterator4.s();
            case 3:
              if ((_step4 = _iterator4.n()).done) {
                _context7.n = 7;
                break;
              }
              index = _step4.value;
              if (Number(index.unique)) {
                _context7.n = 4;
                break;
              }
              return _context7.a(3, 6);
            case 4:
              _context7.n = 5;
              return db.all("PRAGMA index_info(".concat(quoteIdentifier(index.name), ")"));
            case 5:
              columns = _context7.v;
              if (!(columns.length === 1 && columns[0].name === 'signature')) {
                _context7.n = 6;
                break;
              }
              return _context7.a(2, index);
            case 6:
              _context7.n = 3;
              break;
            case 7:
              _context7.n = 9;
              break;
            case 8:
              _context7.p = 8;
              _t0 = _context7.v;
              _iterator4.e(_t0);
            case 9:
              _context7.p = 9;
              _iterator4.f();
              return _context7.f(9);
            case 10:
              return _context7.a(2, null);
          }
        }, _callee6, null, [[2, 8, 9, 10]]);
      }));
      function returnLegacySignatureIndex(_x2) {
        return _returnLegacySignatureIndex.apply(this, arguments);
      }
      return returnLegacySignatureIndex;
    }()
    /**
     * Recreate listings from sql/listings.sql, keeping the rows and any retired column
     * the live table still carries. The definition is replayed verbatim so a migrated
     * database is indistinguishable from a fresh install.
     */
  }, {
    key: "rebuildListingsWithoutSignatureUnique",
    value: function () {
      var _rebuildListingsWithoutSignatureUnique = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(db) {
        var statements, existing, snapshot, _iterator5, _step5, sql, rebuilt, rebuilt_names, _iterator6, _step6, column, type, has_default, not_null, fallback, copied, _t1, _t10, _t11, _t12;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              statements = this.returnListingsSchemaStatements();
              if (statements.some(function (sql) {
                return /^CREATE\s+TABLE\b/i.test(sql);
              })) {
                _context8.n = 1;
                break;
              }
              throw new Error('sql/listings.sql does not define the listings table');
            case 1:
              _context8.n = 2;
              return db.all("PRAGMA table_info('listings')");
            case 2:
              existing = _context8.v;
              if (existing !== null && existing !== void 0 && existing.length) {
                _context8.n = 3;
                break;
              }
              throw new Error('listings table is missing');
            case 3:
              snapshot = quoteIdentifier(LISTINGS_MIGRATION_TABLE);
              _context8.n = 4;
              return db.exec('BEGIN IMMEDIATE');
            case 4:
              _context8.p = 4;
              _context8.n = 5;
              return db.exec("DROP TABLE IF EXISTS ".concat(snapshot));
            case 5:
              _context8.n = 6;
              return db.exec("CREATE TABLE ".concat(snapshot, " AS SELECT * FROM listings"));
            case 6:
              _context8.n = 7;
              return db.exec('DROP TABLE listings');
            case 7:
              _iterator5 = _createForOfIteratorHelper(statements);
              _context8.p = 8;
              _iterator5.s();
            case 9:
              if ((_step5 = _iterator5.n()).done) {
                _context8.n = 11;
                break;
              }
              sql = _step5.value;
              _context8.n = 10;
              return db.exec(sql);
            case 10:
              _context8.n = 9;
              break;
            case 11:
              _context8.n = 13;
              break;
            case 12:
              _context8.p = 12;
              _t1 = _context8.v;
              _iterator5.e(_t1);
            case 13:
              _context8.p = 13;
              _iterator5.f();
              return _context8.f(13);
            case 14:
              _context8.n = 15;
              return db.all("PRAGMA table_info('listings')");
            case 15:
              rebuilt = _context8.v;
              rebuilt_names = new Set((rebuilt || []).map(function (column) {
                return column.name;
              }));
              _iterator6 = _createForOfIteratorHelper(existing);
              _context8.p = 16;
              _iterator6.s();
            case 17:
              if ((_step6 = _iterator6.n()).done) {
                _context8.n = 20;
                break;
              }
              column = _step6.value;
              if (!rebuilt_names.has(column.name)) {
                _context8.n = 18;
                break;
              }
              return _context8.a(3, 19);
            case 18:
              // Column this checkout no longer defines but the live table still carries:
              // re-add it exactly as it was so schema audits see no drift.
              type = String(column.type || '').trim() || 'TEXT';
              has_default = column.dflt_value !== null && column.dflt_value !== undefined; // ADD COLUMN can only assert NOT NULL when it has a default to backfill with.
              not_null = Number(column.notnull) === 1 && has_default ? ' NOT NULL' : '';
              fallback = has_default ? " DEFAULT ".concat(column.dflt_value) : '';
              _context8.n = 19;
              return db.exec("ALTER TABLE listings\n\t\t\t\t\t ADD COLUMN ".concat(columnIdentifier(column.name), " ").concat(type).concat(not_null).concat(fallback));
            case 19:
              _context8.n = 17;
              break;
            case 20:
              _context8.n = 22;
              break;
            case 21:
              _context8.p = 21;
              _t10 = _context8.v;
              _iterator6.e(_t10);
            case 22:
              _context8.p = 22;
              _iterator6.f();
              return _context8.f(22);
            case 23:
              copied = existing.map(function (column) {
                return quoteIdentifier(column.name);
              }).join(', ');
              _context8.n = 24;
              return db.exec("INSERT INTO listings (".concat(copied, ") SELECT ").concat(copied, " FROM ").concat(snapshot));
            case 24:
              _context8.n = 25;
              return db.exec("DROP TABLE ".concat(snapshot));
            case 25:
              _context8.n = 26;
              return db.exec('COMMIT');
            case 26:
              _context8.n = 32;
              break;
            case 27:
              _context8.p = 27;
              _t11 = _context8.v;
              _context8.p = 28;
              _context8.n = 29;
              return db.exec('ROLLBACK');
            case 29:
              _context8.n = 31;
              break;
            case 30:
              _context8.p = 30;
              _t12 = _context8.v;
            case 31:
              throw _t11;
            case 32:
              return _context8.a(2);
          }
        }, _callee7, this, [[28, 30], [16, 21, 22, 23], [8, 12, 13, 14], [4, 27]]);
      }));
      function rebuildListingsWithoutSignatureUnique(_x3) {
        return _rebuildListingsWithoutSignatureUnique.apply(this, arguments);
      }
      return rebuildListingsWithoutSignatureUnique;
    }()
  }, {
    key: "returnListingsSchemaStatements",
    value: function returnListingsSchemaStatements() {
      return this.returnSchemaStatements('listings.sql');
    }
  }, {
    key: "migrateListingChainFields",
    value: function () {
      var _migrateListingChainFields = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var migrations, _i3, _migrations, sql, _t13;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              migrations = ["UPDATE listings\n\t\t\t SET block_id_listed = block_id,\n\t\t\t     block_hash_listed = block_hash,\n\t\t\t     transaction_id_listed = transaction_id,\n\t\t\t     longest_chain_listed = longest_chain\n\t\t\t WHERE block_id_listed = 0 AND block_id != 0", "UPDATE listings\n\t\t\t SET longest_chain_sold = 1\n\t\t\t WHERE block_id_sold = 0 AND spent = 1 AND block_id != 0", "UPDATE listings\n\t\t\t SET block_id_sold = block_id,\n\t\t\t     block_hash_sold = block_hash,\n\t\t\t     transaction_id_sold = transaction_id,\n\t\t\t     longest_chain_sold = longest_chain\n\t\t\t WHERE block_id_sold = 0 AND spent = 1 AND block_id != 0"];
              _i3 = 0, _migrations = migrations;
            case 1:
              if (!(_i3 < _migrations.length)) {
                _context9.n = 6;
                break;
              }
              sql = _migrations[_i3];
              _context9.p = 2;
              _context9.n = 3;
              return this.app.storage.runDatabase(sql, {}, this.dbname);
            case 3:
              _context9.n = 5;
              break;
            case 4:
              _context9.p = 4;
              _t13 = _context9.v;
            case 5:
              _i3++;
              _context9.n = 1;
              break;
            case 6:
              return _context9.a(2);
          }
        }, _callee8, this, [[2, 4]]);
      }));
      function migrateListingChainFields() {
        return _migrateListingChainFields.apply(this, arguments);
      }
      return migrateListingChainFields;
    }()
  }, {
    key: "migrateOrderChainFields",
    value: function () {
      var _migrateOrderChainFields = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var migrations, _i4, _migrations2, sql, _t14;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              migrations = ["UPDATE orders\n\t\t\t SET block_id_received = block_id_added,\n\t\t\t     block_hash_received = block_hash_added,\n\t\t\t     transaction_id_received = transaction_id_added,\n\t\t\t     longest_chain_received = longest_chain_added\n\t\t\t WHERE block_id_received = 0 AND block_id_added != 0", "UPDATE orders\n\t\t\t SET block_id_fulfilled = block_id_confirmed,\n\t\t\t     block_hash_fulfilled = block_hash_confirmed,\n\t\t\t     transaction_id_fulfilled = transaction_id_confirmed,\n\t\t\t     longest_chain_fulfilled = longest_chain_confirmed\n\t\t\t WHERE block_id_fulfilled = 0 AND block_id_confirmed != 0"];
              _i4 = 0, _migrations2 = migrations;
            case 1:
              if (!(_i4 < _migrations2.length)) {
                _context0.n = 6;
                break;
              }
              sql = _migrations2[_i4];
              _context0.p = 2;
              _context0.n = 3;
              return this.app.storage.runDatabase(sql, {}, this.dbname);
            case 3:
              _context0.n = 5;
              break;
            case 4:
              _context0.p = 4;
              _t14 = _context0.v;
            case 5:
              _i4++;
              _context0.n = 1;
              break;
            case 6:
              return _context0.a(2);
          }
        }, _callee9, this, [[2, 4]]);
      }));
      function migrateOrderChainFields() {
        return _migrateOrderChainFields.apply(this, arguments);
      }
      return migrateOrderChainFields;
    }() /** Rename legacy payment_* crypto columns on orders. */
  }, {
    key: "migrateOrderCryptoFieldNames",
    value: function () {
      var _migrateOrderCryptoFieldNames = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var renames, _i5, _renames, _renames$_i, from, to, _t15;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              renames = [['payment_utxo_slip', 'utxo_slip'], ['payment_access_hash', 'access_hash'], ['payment_access_script', 'access_script'], ['payment_p2sh_address', 'p2sh_address']];
              _i5 = 0, _renames = renames;
            case 1:
              if (!(_i5 < _renames.length)) {
                _context1.n = 6;
                break;
              }
              _renames$_i = _slicedToArray(_renames[_i5], 2), from = _renames$_i[0], to = _renames$_i[1];
              _context1.p = 2;
              _context1.n = 3;
              return this.app.storage.runDatabase("ALTER TABLE orders RENAME COLUMN ".concat(from, " TO ").concat(to), {}, this.dbname);
            case 3:
              _context1.n = 5;
              break;
            case 4:
              _context1.p = 4;
              _t15 = _context1.v;
            case 5:
              _i5++;
              _context1.n = 1;
              break;
            case 6:
              return _context1.a(2);
          }
        }, _callee0, this, [[2, 4]]);
      }));
      function migrateOrderCryptoFieldNames() {
        return _migrateOrderCryptoFieldNames.apply(this, arguments);
      }
      return migrateOrderCryptoFieldNames;
    }() // --- listings (authoritative: one row per listing transaction) ---
  }, {
    key: "insertListingRow",
    value: function () {
      var _insertListingRow = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(row) {
        var _row$quantity, _row$price, _row$slip_id, _ref, _row$block_id_listed, _ref2, _row$transaction_id_l, _ref3, _row$longest_chain_li, _row$block_id_sold, _row$transaction_id_s, _row$longest_chain_so, _row$settlement_pendi, _row$on_chain, _row$approved;
        var risk, sql, params, db;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              risk = row.risk === 'Low' || row.risk === 'Medium' || row.risk === 'High' || row.risk === 'Dangerous' ? row.risk : '';
              sql = "INSERT INTO listings (\n\t\t\t  signature, nft_id, seller, category, quantity, price, web3_ticker, web3_amount,\n\t\t\t  access_hash, access_script, p2sh_address, slip_id,\n\t\t\t  block_id_listed, block_hash_listed, transaction_id_listed, longest_chain_listed,\n\t\t\t  block_id_sold, block_hash_sold, transaction_id_sold, longest_chain_sold,\n\t\t\t  settlement_pending, on_chain,\n\t\t\t  utxo_slip1, utxo_slip2, utxo_slip3,\n\t\t\t  created_at, updated_at, risk, approved\n\t\t\t) VALUES (\n\t\t\t  $signature, $nft_id, $seller, $category, $quantity, $price, $web3_ticker, $web3_amount,\n\t\t\t  $access_hash, $access_script, $p2sh_address, $slip_id,\n\t\t\t  $block_id_listed, $block_hash_listed, $transaction_id_listed, $longest_chain_listed,\n\t\t\t  $block_id_sold, $block_hash_sold, $transaction_id_sold, $longest_chain_sold,\n\t\t\t  $settlement_pending, $on_chain,\n\t\t\t  $utxo_slip1, $utxo_slip2, $utxo_slip3,\n\t\t\t  $created_at, $updated_at, $risk, $approved\n\t\t\t)";
              params = {
                $signature: row.signature,
                $nft_id: row.nft_id,
                $seller: row.seller || '',
                $category: row.category || STORE_CATEGORIES.OTHER,
                $quantity: Number((_row$quantity = row.quantity) !== null && _row$quantity !== void 0 ? _row$quantity : 1),
                $price: Number((_row$price = row.price) !== null && _row$price !== void 0 ? _row$price : 0),
                $web3_ticker: String(row.web3_ticker || '').trim().toUpperCase(),
                $web3_amount: String(row.web3_amount || '').trim(),
                $access_hash: row.access_hash || '',
                $access_script: row.access_script || '',
                $p2sh_address: row.p2sh_address || '',
                $slip_id: (_row$slip_id = row.slip_id) !== null && _row$slip_id !== void 0 ? _row$slip_id : 0,
                $block_id_listed: (_ref = (_row$block_id_listed = row.block_id_listed) !== null && _row$block_id_listed !== void 0 ? _row$block_id_listed : row.block_id) !== null && _ref !== void 0 ? _ref : 0,
                $block_hash_listed: row.block_hash_listed || row.block_hash || '',
                $transaction_id_listed: (_ref2 = (_row$transaction_id_l = row.transaction_id_listed) !== null && _row$transaction_id_l !== void 0 ? _row$transaction_id_l : row.transaction_id) !== null && _ref2 !== void 0 ? _ref2 : 0,
                $longest_chain_listed: (_ref3 = (_row$longest_chain_li = row.longest_chain_listed) !== null && _row$longest_chain_li !== void 0 ? _row$longest_chain_li : row.longest_chain) !== null && _ref3 !== void 0 ? _ref3 : 1,
                $block_id_sold: (_row$block_id_sold = row.block_id_sold) !== null && _row$block_id_sold !== void 0 ? _row$block_id_sold : 0,
                $block_hash_sold: row.block_hash_sold || '',
                $transaction_id_sold: (_row$transaction_id_s = row.transaction_id_sold) !== null && _row$transaction_id_s !== void 0 ? _row$transaction_id_s : 0,
                $longest_chain_sold: (_row$longest_chain_so = row.longest_chain_sold) !== null && _row$longest_chain_so !== void 0 ? _row$longest_chain_so : 0,
                $settlement_pending: Number((_row$settlement_pendi = row.settlement_pending) !== null && _row$settlement_pendi !== void 0 ? _row$settlement_pendi : 0) ? 1 : 0,
                $on_chain: (_row$on_chain = row.on_chain) !== null && _row$on_chain !== void 0 ? _row$on_chain : 1,
                $utxo_slip1: row.utxo_slip1 || '',
                $utxo_slip2: row.utxo_slip2 || '',
                $utxo_slip3: row.utxo_slip3 || '',
                $created_at: row.created_at,
                $updated_at: row.updated_at,
                $risk: risk,
                $approved: Number((_row$approved = row.approved) !== null && _row$approved !== void 0 ? _row$approved : 0) || 0
              }; // Bypass runDatabase so insert failures surface (runDatabase swallows errors).
              _context10.n = 1;
              return this.app.storage.returnDatabaseByName(this.dbname);
            case 1:
              db = _context10.v;
              if (db) {
                _context10.n = 2;
                break;
              }
              throw new Error('Store database unavailable');
            case 2:
              _context10.n = 3;
              return db.run(sql, params);
            case 3:
              return _context10.a(2);
          }
        }, _callee1, this);
      }));
      function insertListingRow(_x4) {
        return _insertListingRow.apply(this, arguments);
      }
      return insertListingRow;
    }() /** One exact inclusion of a listing transaction. */
  }, {
    key: "returnListingBySignatureAndBlockHash",
    value: function () {
      var _returnListingBySignatureAndBlockHash = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(signature, block_hash_listed) {
        var res;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              _context11.n = 1;
              return this.app.storage.queryDatabase("SELECT * FROM listings\n\t\t\t WHERE signature = $signature AND block_hash_listed = $block_hash_listed\n\t\t\t LIMIT 1", {
                $signature: String(signature || ''),
                $block_hash_listed: String(block_hash_listed || '')
              }, this.dbname);
            case 1:
              res = _context11.v;
              return _context11.a(2, (res === null || res === void 0 ? void 0 : res[0]) || null);
          }
        }, _callee10, this);
      }));
      function returnListingBySignatureAndBlockHash(_x5, _x6) {
        return _returnListingBySignatureAndBlockHash.apply(this, arguments);
      }
      return returnListingBySignatureAndBlockHash;
    }()
    /**
     * The inclusion a listing transaction currently has on the longest chain. Inventory
     * operations must use this row: its slips are the ones the chain can still spend.
     */
  }, {
    key: "returnCanonicalListingBySignature",
    value: function () {
      var _returnCanonicalListingBySignature = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(signature) {
        var res;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              _context12.n = 1;
              return this.app.storage.queryDatabase("SELECT * FROM listings\n\t\t\t WHERE signature = $signature\n\t\t\t   AND on_chain = 1\n\t\t\t   AND longest_chain_listed = 1\n\t\t\t ORDER BY block_id_listed DESC, id DESC\n\t\t\t LIMIT 1", {
                $signature: String(signature || '')
              }, this.dbname);
            case 1:
              res = _context12.v;
              return _context12.a(2, (res === null || res === void 0 ? void 0 : res[0]) || null);
          }
        }, _callee11, this);
      }));
      function returnCanonicalListingBySignature(_x7) {
        return _returnCanonicalListingBySignature.apply(this, arguments);
      }
      return returnCanonicalListingBySignature;
    }()
    /**
     * Newest moderation decision for this seller and NFT.
     * 1 = approved, 2 = pending review, -1 = rejected. 0 = none.
     * A partial sale relists the remainder under a new signature; callers use
     * this so that decision follows the NFT instead of the spent transaction.
     */
  }, {
    key: "returnLatestNftModeration",
    value: function () {
      var _returnLatestNftModeration = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(nft_id, seller) {
        var id, key, _res$0$approved, _res$, res, approved, _t16;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.p = _context13.n) {
            case 0:
              id = String(nft_id || '').trim();
              key = String(seller || '').trim();
              if (!(!id || !key)) {
                _context13.n = 1;
                break;
              }
              return _context13.a(2, 0);
            case 1:
              _context13.p = 1;
              _context13.n = 2;
              return this.app.storage.queryDatabase("SELECT approved FROM listings\n\t\t\t\t WHERE nft_id = $nft_id\n\t\t\t\t   AND seller = $seller\n\t\t\t\t   AND approved != 0\n\t\t\t\t ORDER BY block_id_listed DESC, id DESC\n\t\t\t\t LIMIT 1", {
                $nft_id: id,
                $seller: key
              }, this.dbname);
            case 2:
              res = _context13.v;
              approved = Number((_res$0$approved = res === null || res === void 0 || (_res$ = res[0]) === null || _res$ === void 0 ? void 0 : _res$.approved) !== null && _res$0$approved !== void 0 ? _res$0$approved : 0);
              if (!(approved === 1 || approved === 2 || approved === -1)) {
                _context13.n = 3;
                break;
              }
              return _context13.a(2, approved);
            case 3:
              _context13.n = 5;
              break;
            case 4:
              _context13.p = 4;
              _t16 = _context13.v;
              return _context13.a(2, 0);
            case 5:
              return _context13.a(2, 0);
          }
        }, _callee12, this, [[1, 4]]);
      }));
      function returnLatestNftModeration(_x8, _x9) {
        return _returnLatestNftModeration.apply(this, arguments);
      }
      return returnLatestNftModeration;
    }() /** Newest stored inclusion of a listing transaction, on the longest chain or not. */
  }, {
    key: "returnLatestListingInclusion",
    value: function () {
      var _returnLatestListingInclusion = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(signature) {
        var res;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              _context14.n = 1;
              return this.app.storage.queryDatabase("SELECT * FROM listings\n\t\t\t WHERE signature = $signature\n\t\t\t ORDER BY block_id_listed DESC, id DESC\n\t\t\t LIMIT 1", {
                $signature: String(signature || '')
              }, this.dbname);
            case 1:
              res = _context14.v;
              return _context14.a(2, (res === null || res === void 0 ? void 0 : res[0]) || null);
          }
        }, _callee13, this);
      }));
      function returnLatestListingInclusion(_x0) {
        return _returnLatestListingInclusion.apply(this, arguments);
      }
      return returnLatestListingInclusion;
    }()
    /**
     * WHERE clause selecting exactly one inclusion of $signature: the given block hash
     * when the caller knows which inclusion it spent, otherwise the canonical row.
     */
  }, {
    key: "listingInclusionWhere",
    value: function listingInclusionWhere() {
      var block_hash_listed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (block_hash_listed === null || block_hash_listed === undefined) {
        return {
          sql: "id = (\n\t\t\t\t\t  SELECT id FROM listings\n\t\t\t\t\t   WHERE signature = $signature\n\t\t\t\t\t     AND on_chain = 1\n\t\t\t\t\t     AND longest_chain_listed = 1\n\t\t\t\t\t   ORDER BY block_id_listed DESC, id DESC\n\t\t\t\t\t   LIMIT 1\n\t\t\t\t\t)",
          params: {}
        };
      }
      return {
        sql: 'signature = $signature AND block_hash_listed = $block_hash_listed',
        params: {
          $block_hash_listed: String(block_hash_listed)
        }
      };
    }

    /**
     * Listed on the longest chain, not reserved locally, and no sale inclusion
     * of this listing inclusion is currently canonical.
     */
  }, {
    key: "availableListingWhere",
    value: function availableListingWhere() {
      return "on_chain = 1\n\t\t\t\t   AND longest_chain_listed = 1\n\t\t\t\t   AND settlement_pending = 0\n\t\t\t\t   AND NOT EXISTS (\n\t\t\t\t     SELECT 1 FROM listing_sales\n\t\t\t\t      WHERE listing_sales.signature = listings.signature\n\t\t\t\t        AND listing_sales.block_hash_listed = listings.block_hash_listed\n\t\t\t\t        AND listing_sales.longest_chain_sold = 1\n\t\t\t\t   )";
    }

    /** A sale inclusion of this listing inclusion is on the longest chain. */
  }, {
    key: "canonicalSaleWhere",
    value: function canonicalSaleWhere() {
      return "EXISTS (\n\t\t\t\t     SELECT 1 FROM listing_sales\n\t\t\t\t      WHERE listing_sales.signature = listings.signature\n\t\t\t\t        AND listing_sales.block_hash_listed = listings.block_hash_listed\n\t\t\t\t        AND listing_sales.longest_chain_sold = 1\n\t\t\t\t   )";
    }
  }, {
    key: "returnSpendableListingsForBucket",
    value: function () {
      var _returnSpendableListingsForBucket = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(nft_id, price) {
        var limit,
          _args15 = arguments,
          _t17;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.p = _context15.n) {
            case 0:
              limit = _args15.length > 2 && _args15[2] !== undefined ? _args15[2] : 1;
              _context15.p = 1;
              _context15.n = 2;
              return this.app.storage.queryDatabase("SELECT * FROM listings\n\t\t\t\t WHERE nft_id = $nft_id AND price = $price\n\t\t\t\t   AND ".concat(this.availableListingWhere(), "\n\t\t\t\t ORDER BY created_at ASC, id ASC\n\t\t\t\t LIMIT $limit"), {
                $nft_id: nft_id,
                $price: Number(price),
                $limit: Number(limit) || 1
              }, this.dbname);
            case 2:
              return _context15.a(2, _context15.v);
            case 3:
              _context15.p = 3;
              _t17 = _context15.v;
              return _context15.a(2, []);
          }
        }, _callee14, this, [[1, 3]]);
      }));
      function returnSpendableListingsForBucket(_x1, _x10) {
        return _returnSpendableListingsForBucket.apply(this, arguments);
      }
      return returnSpendableListingsForBucket;
    }()
  }, {
    key: "returnLowestSatisfyingPriceForNft",
    value: function () {
      var _returnLowestSatisfyingPriceForNft = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(nft_id, max_price, quantity) {
        var res, _t18;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.p = _context16.n) {
            case 0:
              _context16.p = 0;
              _context16.n = 1;
              return this.app.storage.queryDatabase("SELECT price, SUM(quantity) AS total_quantity\n\t\t\t\t FROM listings\n\t\t\t\t WHERE nft_id = $nft_id AND price <= $max_price\n\t\t\t\t   AND ".concat(this.availableListingWhere(), "\n\t\t\t\t GROUP BY price\n\t\t\t\t HAVING SUM(quantity) >= $quantity\n\t\t\t\t ORDER BY price ASC\n\t\t\t\t LIMIT 1"), {
                $nft_id: nft_id,
                $max_price: Number(max_price),
                $quantity: Number(quantity) || 1
              }, this.dbname);
            case 1:
              res = _context16.v;
              if (res !== null && res !== void 0 && res[0]) {
                _context16.n = 2;
                break;
              }
              return _context16.a(2, null);
            case 2:
              return _context16.a(2, Number(res[0].price));
            case 3:
              _context16.p = 3;
              _t18 = _context16.v;
              return _context16.a(2, null);
          }
        }, _callee15, this, [[0, 3]]);
      }));
      function returnLowestSatisfyingPriceForNft(_x11, _x12, _x13) {
        return _returnLowestSatisfyingPriceForNft.apply(this, arguments);
      }
      return returnLowestSatisfyingPriceForNft;
    }()
  }, {
    key: "returnActiveListingForBucket",
    value: function () {
      var _returnActiveListingForBucket = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(nft_id, price) {
        var rows;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.n) {
            case 0:
              _context17.n = 1;
              return this.returnSpendableListingsForBucket(nft_id, price, 1);
            case 1:
              rows = _context17.v;
              return _context17.a(2, (rows === null || rows === void 0 ? void 0 : rows[0]) || null);
          }
        }, _callee16, this);
      }));
      function returnActiveListingForBucket(_x14, _x15) {
        return _returnActiveListingForBucket.apply(this, arguments);
      }
      return returnActiveListingForBucket;
    }()
  }, {
    key: "returnAllActiveListingRows",
    value: function () {
      var _returnAllActiveListingRows = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17() {
        var _t19;
        return _regenerator().w(function (_context18) {
          while (1) switch (_context18.p = _context18.n) {
            case 0:
              _context18.p = 0;
              _context18.n = 1;
              return this.app.storage.queryDatabase("SELECT * FROM listings\n\t\t\t\t WHERE ".concat(this.availableListingWhere(), "\n\t\t\t\t ORDER BY created_at ASC"), {}, this.dbname);
            case 1:
              return _context18.a(2, _context18.v);
            case 2:
              _context18.p = 2;
              _t19 = _context18.v;
              return _context18.a(2, []);
          }
        }, _callee17, this, [[0, 2]]);
      }));
      function returnAllActiveListingRows() {
        return _returnAllActiveListingRows.apply(this, arguments);
      }
      return returnAllActiveListingRows;
    }()
    /**
     * Inclusions that stored the three output slips. Not filtered by availability:
     * the fulfillment match is the outpoint, including an inclusion whose last
     * sale is currently off the longest chain.
     */
  }, {
    key: "returnListingRowsForSpendMatch",
    value: function () {
      var _returnListingRowsForSpendMatch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18() {
        var _t20;
        return _regenerator().w(function (_context19) {
          while (1) switch (_context19.p = _context19.n) {
            case 0:
              _context19.p = 0;
              _context19.n = 1;
              return this.app.storage.queryDatabase("SELECT signature, block_hash_listed, quantity, nft_id, price,\n\t\t\t\t        utxo_slip1, utxo_slip2, utxo_slip3\n\t\t\t\t   FROM listings\n\t\t\t\t  WHERE utxo_slip1 != ''\n\t\t\t\t    AND utxo_slip2 != ''\n\t\t\t\t    AND utxo_slip3 != ''", {}, this.dbname);
            case 1:
              return _context19.a(2, _context19.v);
            case 2:
              _context19.p = 2;
              _t20 = _context19.v;
              return _context19.a(2, []);
          }
        }, _callee18, this, [[0, 2]]);
      }));
      function returnListingRowsForSpendMatch() {
        return _returnListingRowsForSpendMatch.apply(this, arguments);
      }
      return returnListingRowsForSpendMatch;
    }()
  }, {
    key: "countListingsInBlock",
    value: function () {
      var _countListingsInBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(block_id, block_hash) {
        var _rows$0$n, _rows$, rows, _t21;
        return _regenerator().w(function (_context20) {
          while (1) switch (_context20.p = _context20.n) {
            case 0:
              _context20.p = 0;
              _context20.n = 1;
              return this.app.storage.queryDatabase("SELECT COUNT(*) AS n\n\t\t\t\t   FROM listings\n\t\t\t\t  WHERE block_id_listed = $block_id\n\t\t\t\t    AND block_hash_listed = $block_hash", {
                $block_id: Number(block_id !== null && block_id !== void 0 ? block_id : 0),
                $block_hash: String(block_hash !== null && block_hash !== void 0 ? block_hash : '')
              }, this.dbname);
            case 1:
              rows = _context20.v;
              return _context20.a(2, Number((_rows$0$n = rows === null || rows === void 0 || (_rows$ = rows[0]) === null || _rows$ === void 0 ? void 0 : _rows$.n) !== null && _rows$0$n !== void 0 ? _rows$0$n : 0));
            case 2:
              _context20.p = 2;
              _t21 = _context20.v;
              return _context20.a(2, 0);
          }
        }, _callee19, this, [[0, 2]]);
      }));
      function countListingsInBlock(_x16, _x17) {
        return _countListingsInBlock.apply(this, arguments);
      }
      return countListingsInBlock;
    }()
  }, {
    key: "countListingSalesForBlock",
    value: function () {
      var _countListingSalesForBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(block_id, block_hash) {
        var _rows$0$n2, _rows$2, rows, _t22;
        return _regenerator().w(function (_context21) {
          while (1) switch (_context21.p = _context21.n) {
            case 0:
              _context21.p = 0;
              _context21.n = 1;
              return this.app.storage.queryDatabase("SELECT COUNT(*) AS n\n\t\t\t\t   FROM listing_sales\n\t\t\t\t  WHERE block_id_sold = $block_id\n\t\t\t\t    AND block_hash_sold = $block_hash", {
                $block_id: Number(block_id !== null && block_id !== void 0 ? block_id : 0),
                $block_hash: String(block_hash !== null && block_hash !== void 0 ? block_hash : '')
              }, this.dbname);
            case 1:
              rows = _context21.v;
              return _context21.a(2, Number((_rows$0$n2 = rows === null || rows === void 0 || (_rows$2 = rows[0]) === null || _rows$2 === void 0 ? void 0 : _rows$2.n) !== null && _rows$0$n2 !== void 0 ? _rows$0$n2 : 0));
            case 2:
              _context21.p = 2;
              _t22 = _context21.v;
              return _context21.a(2, 0);
          }
        }, _callee20, this, [[0, 2]]);
      }));
      function countListingSalesForBlock(_x18, _x19) {
        return _countListingSalesForBlock.apply(this, arguments);
      }
      return countListingSalesForBlock;
    }()
  }, {
    key: "revealListingsInBlock",
    value: function () {
      var _revealListingsInBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(block_id, block_hash) {
        return _regenerator().w(function (_context22) {
          while (1) switch (_context22.n) {
            case 0:
              _context22.n = 1;
              return this.app.storage.runDatabase("UPDATE listings SET longest_chain_listed = 1\n\t\t\t  WHERE block_id_listed = $block_id AND block_hash_listed = $block_hash", {
                $block_id: Number(block_id) || 0,
                $block_hash: String(block_hash || '')
              }, this.dbname);
            case 1:
              return _context22.a(2);
          }
        }, _callee21, this);
      }));
      function revealListingsInBlock(_x20, _x21) {
        return _revealListingsInBlock.apply(this, arguments);
      }
      return revealListingsInBlock;
    }()
    /**
     * Record one fulfillment block's sale of a single listing inclusion.
     * A different fulfillment block inserts its own listing_sales row.
     * block_hash_listed is the inclusion whose outpoints were spent. It is required.
     * The columns on listings are a snapshot of this canonical sale, not the reorg key.
     */
  }, {
    key: "markListingSold",
    value: function () {
      var _markListingSold = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23(signature) {
        var _ref4,
          _ref4$block_hash_list,
          block_hash_listed,
          _ref4$sold_block_id,
          sold_block_id,
          _ref4$sold_block_hash,
          sold_block_hash,
          _ref4$sold_transactio,
          sold_transaction_id,
          _ref4$note,
          note,
          _ref4$buyer,
          buyer,
          _ref4$quantity_sold,
          quantity_sold,
          _ref4$sold_at,
          sold_at,
          now,
          listed_hash,
          inclusion,
          sale_hash,
          params,
          _args24 = arguments;
        return _regenerator().w(function (_context24) {
          while (1) switch (_context24.n) {
            case 0:
              _ref4 = _args24.length > 1 && _args24[1] !== undefined ? _args24[1] : {}, _ref4$block_hash_list = _ref4.block_hash_listed, block_hash_listed = _ref4$block_hash_list === void 0 ? null : _ref4$block_hash_list, _ref4$sold_block_id = _ref4.sold_block_id, sold_block_id = _ref4$sold_block_id === void 0 ? 0 : _ref4$sold_block_id, _ref4$sold_block_hash = _ref4.sold_block_hash, sold_block_hash = _ref4$sold_block_hash === void 0 ? '' : _ref4$sold_block_hash, _ref4$sold_transactio = _ref4.sold_transaction_id, sold_transaction_id = _ref4$sold_transactio === void 0 ? 0 : _ref4$sold_transactio, _ref4$note = _ref4.note, note = _ref4$note === void 0 ? '' : _ref4$note, _ref4$buyer = _ref4.buyer, buyer = _ref4$buyer === void 0 ? '' : _ref4$buyer, _ref4$quantity_sold = _ref4.quantity_sold, quantity_sold = _ref4$quantity_sold === void 0 ? 0 : _ref4$quantity_sold, _ref4$sold_at = _ref4.sold_at, sold_at = _ref4$sold_at === void 0 ? 0 : _ref4$sold_at;
              now = _args24.length > 2 && _args24[2] !== undefined ? _args24[2] : Date.now();
              listed_hash = block_hash_listed === null || block_hash_listed === undefined ? '' : String(block_hash_listed);
              if (listed_hash) {
                _context24.n = 1;
                break;
              }
              console.warn('Store: refusing to record a sale without the listing inclusion hash', signature);
              return _context24.a(2);
            case 1:
              _context24.n = 2;
              return this.returnListingBySignatureAndBlockHash(signature, listed_hash);
            case 2:
              inclusion = _context24.v;
              if (inclusion) {
                _context24.n = 3;
                break;
              }
              return _context24.a(2);
            case 3:
              sale_hash = String(sold_block_hash || '');
              if (sale_hash) {
                _context24.n = 4;
                break;
              }
              return _context24.a(2);
            case 4:
              params = {
                $signature: String(signature || ''),
                $block_hash_listed: String(inclusion.block_hash_listed || ''),
                $block_id_sold: Number(sold_block_id !== null && sold_block_id !== void 0 ? sold_block_id : 0),
                $block_hash_sold: sale_hash,
                $transaction_id_sold: Number(sold_transaction_id !== null && sold_transaction_id !== void 0 ? sold_transaction_id : 0),
                $note: String(note || ''),
                $buyer: String(buyer || ''),
                $quantity_sold: Math.max(0, Number(quantity_sold !== null && quantity_sold !== void 0 ? quantity_sold : 0) || 0),
                $sold_at: Number(sold_at || now) || now,
                $updated_at: now
              };
              _context24.n = 5;
              return this.withImmediateTransaction(/*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(db) {
                  return _regenerator().w(function (_context23) {
                    while (1) switch (_context23.n) {
                      case 0:
                        _context23.n = 1;
                        return db.run("INSERT INTO listing_sales (\n\t\t\t\t\t  signature, block_hash_listed,\n\t\t\t\t\t  block_id_sold, block_hash_sold, transaction_id_sold, longest_chain_sold,\n\t\t\t\t\t  buyer, note, quantity_sold, sold_at, created_at, updated_at\n\t\t\t\t\t) VALUES (\n\t\t\t\t\t  $signature, $block_hash_listed,\n\t\t\t\t\t  $block_id_sold, $block_hash_sold, $transaction_id_sold, 1,\n\t\t\t\t\t  $buyer, $note, $quantity_sold, $sold_at, $updated_at, $updated_at\n\t\t\t\t\t)\n\t\t\t\t\tON CONFLICT(signature, block_hash_listed, block_hash_sold) DO UPDATE SET\n\t\t\t\t\t  block_id_sold = excluded.block_id_sold,\n\t\t\t\t\t  transaction_id_sold = excluded.transaction_id_sold,\n\t\t\t\t\t  longest_chain_sold = 1,\n\t\t\t\t\t  buyer = excluded.buyer,\n\t\t\t\t\t  note = excluded.note,\n\t\t\t\t\t  quantity_sold = excluded.quantity_sold,\n\t\t\t\t\t  sold_at = excluded.sold_at,\n\t\t\t\t\t  updated_at = excluded.updated_at", params);
                      case 1:
                        _context23.n = 2;
                        return db.run("UPDATE listings\n\t\t\t\t SET block_id_sold = $block_id_sold,\n\t\t\t\t     block_hash_sold = $block_hash_sold,\n\t\t\t\t     transaction_id_sold = $transaction_id_sold,\n\t\t\t\t     longest_chain_sold = 1,\n\t\t\t\t     settlement_pending = 0,\n\t\t\t\t     note = $note,\n\t\t\t\t     buyer = $buyer,\n\t\t\t\t     quantity_sold = $quantity_sold,\n\t\t\t\t     sold_at = $sold_at,\n\t\t\t\t     updated_at = $updated_at\n\t\t\t\t WHERE signature = $signature AND block_hash_listed = $block_hash_listed", params);
                      case 2:
                        return _context23.a(2);
                    }
                  }, _callee22);
                }));
                return function (_x23) {
                  return _ref5.apply(this, arguments);
                };
              }());
            case 5:
              return _context24.a(2);
          }
        }, _callee23, this);
      }));
      function markListingSold(_x22) {
        return _markListingSold.apply(this, arguments);
      }
      return markListingSold;
    }()
    /**
     * Local reservation so the queue does not build a second fulfillment before
     * the first one is in a block. Does not write sale identity or chain flags.
     * Matches an inclusion that is listed and not canonically sold, including one
     * whose last sale block is currently off-chain.
     */
  }, {
    key: "markListingSettlementPending",
    value: function () {
      var _markListingSettlementPending = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24(signature) {
        var block_hash_listed,
          now,
          inclusion,
          _args25 = arguments;
        return _regenerator().w(function (_context25) {
          while (1) switch (_context25.n) {
            case 0:
              block_hash_listed = _args25.length > 1 && _args25[1] !== undefined ? _args25[1] : null;
              now = _args25.length > 2 && _args25[2] !== undefined ? _args25[2] : Date.now();
              inclusion = this.listingInclusionWhere(block_hash_listed);
              _context25.n = 1;
              return this.app.storage.runDatabase("UPDATE listings\n\t\t\t SET settlement_pending = 1,\n\t\t\t     updated_at = $updated_at\n\t\t\t WHERE ".concat(inclusion.sql, "\n\t\t\t   AND longest_chain_listed = 1\n\t\t\t   AND settlement_pending = 0\n\t\t\t   AND NOT EXISTS (\n\t\t\t     SELECT 1 FROM listing_sales\n\t\t\t      WHERE listing_sales.signature = listings.signature\n\t\t\t        AND listing_sales.block_hash_listed = listings.block_hash_listed\n\t\t\t        AND listing_sales.longest_chain_sold = 1\n\t\t\t   )"), _objectSpread(_objectSpread({}, inclusion.params), {}, {
                $signature: signature,
                $updated_at: now
              }), this.dbname);
            case 1:
              return _context25.a(2);
          }
        }, _callee24, this);
      }));
      function markListingSettlementPending(_x24) {
        return _markListingSettlementPending.apply(this, arguments);
      }
      return markListingSettlementPending;
    }()
    /**
     * Drop the local reservation. block_hash_listed narrows it when the caller
     * knows the inclusion. Sale identity is left untouched.
     */
  }, {
    key: "clearListingSettlementPending",
    value: function () {
      var _clearListingSettlementPending = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25(signature) {
        var block_hash_listed,
          now,
          params,
          inclusion_sql,
          _args26 = arguments;
        return _regenerator().w(function (_context26) {
          while (1) switch (_context26.n) {
            case 0:
              block_hash_listed = _args26.length > 1 && _args26[1] !== undefined ? _args26[1] : null;
              now = _args26.length > 2 && _args26[2] !== undefined ? _args26[2] : Date.now();
              params = {
                $signature: signature,
                $updated_at: now
              };
              inclusion_sql = '';
              if (block_hash_listed !== null && block_hash_listed !== undefined) {
                inclusion_sql = ' AND block_hash_listed = $block_hash_listed';
                params.$block_hash_listed = String(block_hash_listed);
              }
              _context26.n = 1;
              return this.app.storage.runDatabase("UPDATE listings\n\t\t\t SET settlement_pending = 0,\n\t\t\t     updated_at = $updated_at\n\t\t\t WHERE signature = $signature\n\t\t\t   AND settlement_pending = 1".concat(inclusion_sql), params, this.dbname);
            case 1:
              return _context26.a(2);
          }
        }, _callee25, this);
      }));
      function clearListingSettlementPending(_x25) {
        return _clearListingSettlementPending.apply(this, arguments);
      }
      return clearListingSettlementPending;
    }()
  }, {
    key: "sumListingQuantityForBucket",
    value: function () {
      var _sumListingQuantityForBucket = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26(nft_id, price) {
        var _res$0$total_quantity, _res$2, res, _t23;
        return _regenerator().w(function (_context27) {
          while (1) switch (_context27.p = _context27.n) {
            case 0:
              _context27.p = 0;
              _context27.n = 1;
              return this.app.storage.queryDatabase("SELECT COALESCE(SUM(quantity), 0) AS total_quantity\n\t\t\t\t FROM listings\n\t\t\t\t WHERE nft_id = $nft_id AND price = $price\n\t\t\t\t   AND ".concat(this.availableListingWhere()), {
                $nft_id: nft_id,
                $price: Number(price)
              }, this.dbname);
            case 1:
              res = _context27.v;
              return _context27.a(2, Number((_res$0$total_quantity = res === null || res === void 0 || (_res$2 = res[0]) === null || _res$2 === void 0 ? void 0 : _res$2.total_quantity) !== null && _res$0$total_quantity !== void 0 ? _res$0$total_quantity : 0));
            case 2:
              _context27.p = 2;
              _t23 = _context27.v;
              return _context27.a(2, 0);
          }
        }, _callee26, this, [[0, 2]]);
      }));
      function sumListingQuantityForBucket(_x26, _x27) {
        return _sumListingQuantityForBucket.apply(this, arguments);
      }
      return sumListingQuantityForBucket;
    }() // Non-reentrant: transaction callbacks must use db directly, not this helper.
  }, {
    key: "withImmediateTransaction",
    value: function () {
      var _withImmediateTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee28(fn) {
        var db, previous, operation;
        return _regenerator().w(function (_context29) {
          while (1) switch (_context29.n) {
            case 0:
              _context29.n = 1;
              return this.app.storage.returnDatabaseByName(this.dbname);
            case 1:
              db = _context29.v;
              if (db) {
                _context29.n = 2;
                break;
              }
              throw new Error('Store database unavailable');
            case 2:
              previous = transactionTails.get(db) || Promise.resolve();
              operation = previous.then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee27() {
                var result, _t24, _t25;
                return _regenerator().w(function (_context28) {
                  while (1) switch (_context28.p = _context28.n) {
                    case 0:
                      _context28.n = 1;
                      return db.exec('BEGIN IMMEDIATE');
                    case 1:
                      _context28.p = 1;
                      _context28.n = 2;
                      return fn(db);
                    case 2:
                      result = _context28.v;
                      _context28.n = 3;
                      return db.exec('COMMIT');
                    case 3:
                      return _context28.a(2, result);
                    case 4:
                      _context28.p = 4;
                      _t24 = _context28.v;
                      _context28.p = 5;
                      _context28.n = 6;
                      return db.exec('ROLLBACK');
                    case 6:
                      _context28.n = 8;
                      break;
                    case 7:
                      _context28.p = 7;
                      _t25 = _context28.v;
                      console.error('Store Database: rollback failed', _t25);
                    case 8:
                      throw _t24;
                    case 9:
                      return _context28.a(2);
                  }
                }, _callee27, null, [[5, 7], [1, 4]]);
              }))); // Recover the queue after failure while preserving rejection for the caller.
              transactionTails.set(db, operation.then(function () {
                return undefined;
              }, function () {
                return undefined;
              }));
              return _context29.a(2, operation);
          }
        }, _callee28, this);
      }));
      function withImmediateTransaction(_x28) {
        return _withImmediateTransaction.apply(this, arguments);
      }
      return withImmediateTransaction;
    }()
    /**
     * Reorg one block. Unwind hides remainder inclusions before the consumed
     * listing can become available. Wind marks the sale canonical before the
     * remainder inclusion becomes visible. Sale identity columns are not cleared.
     */
  }, {
    key: "applyListingChainReorganization",
    value: function () {
      var _applyListingChainReorganization = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee30(block_id, block_hash, longest_chain) {
        var _this = this;
        var reveal_listings,
          on_lc,
          id,
          hash,
          now,
          chain,
          params,
          _args31 = arguments;
        return _regenerator().w(function (_context31) {
          while (1) switch (_context31.n) {
            case 0:
              reveal_listings = _args31.length > 3 && _args31[3] !== undefined ? _args31[3] : true;
              on_lc = !!longest_chain;
              id = Number(block_id) || 0;
              hash = String(block_hash || '');
              now = Date.now();
              chain = {
                $block_id: id,
                $block_hash: hash
              };
              params = _objectSpread(_objectSpread({}, chain), {}, {
                $updated_at: now
              });
              _context31.n = 1;
              return this.withImmediateTransaction(/*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee29(db) {
                  return _regenerator().w(function (_context30) {
                    while (1) switch (_context30.n) {
                      case 0:
                        if (on_lc) {
                          _context30.n = 3;
                          break;
                        }
                        _context30.n = 1;
                        return db.run("UPDATE listings SET longest_chain_listed = 0\n\t\t\t\t\t WHERE block_id_listed = $block_id AND block_hash_listed = $block_hash", chain);
                      case 1:
                        _context30.n = 2;
                        return db.run("UPDATE listing_sales\n\t\t\t\t\t SET longest_chain_sold = 0, updated_at = $updated_at\n\t\t\t\t\t WHERE block_id_sold = $block_id AND block_hash_sold = $block_hash", params);
                      case 2:
                        _context30.n = 4;
                        break;
                      case 3:
                        _context30.n = 4;
                        return db.run("UPDATE listing_sales\n\t\t\t\t\t SET longest_chain_sold = 1, updated_at = $updated_at\n\t\t\t\t\t WHERE block_id_sold = $block_id AND block_hash_sold = $block_hash", params);
                      case 4:
                        _context30.n = 5;
                        return _this.refreshSaleSnapshots(db, params);
                      case 5:
                        if (!(on_lc && reveal_listings)) {
                          _context30.n = 6;
                          break;
                        }
                        _context30.n = 6;
                        return db.run("UPDATE listings SET longest_chain_listed = 1\n\t\t\t\t\t WHERE block_id_listed = $block_id AND block_hash_listed = $block_hash", chain);
                      case 6:
                        return _context30.a(2);
                    }
                  }, _callee29);
                }));
                return function (_x32) {
                  return _ref7.apply(this, arguments);
                };
              }());
            case 1:
              return _context31.a(2);
          }
        }, _callee30, this);
      }));
      function applyListingChainReorganization(_x29, _x30, _x31) {
        return _applyListingChainReorganization.apply(this, arguments);
      }
      return applyListingChainReorganization;
    }()
    /**
     * Copy the canonical sale onto the listing snapshot when one exists.
     * When none does, keep the last sale identity, clear longest_chain_sold, and
     * set longest_chain_listed = -1 so the spent inclusion is not offered again.
     */
  }, {
    key: "refreshSaleSnapshots",
    value: function () {
      var _refreshSaleSnapshots = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee31(db, params) {
        return _regenerator().w(function (_context32) {
          while (1) switch (_context32.n) {
            case 0:
              _context32.n = 1;
              return db.run("UPDATE listings\n\t\t\t SET block_id_sold = (\n\t\t\t       SELECT s.block_id_sold FROM listing_sales s\n\t\t\t        WHERE s.signature = listings.signature\n\t\t\t          AND s.block_hash_listed = listings.block_hash_listed\n\t\t\t          AND s.longest_chain_sold = 1\n\t\t\t        ORDER BY s.block_id_sold DESC, s.id DESC\n\t\t\t        LIMIT 1\n\t\t\t     ),\n\t\t\t     block_hash_sold = (\n\t\t\t       SELECT s.block_hash_sold FROM listing_sales s\n\t\t\t        WHERE s.signature = listings.signature\n\t\t\t          AND s.block_hash_listed = listings.block_hash_listed\n\t\t\t          AND s.longest_chain_sold = 1\n\t\t\t        ORDER BY s.block_id_sold DESC, s.id DESC\n\t\t\t        LIMIT 1\n\t\t\t     ),\n\t\t\t     transaction_id_sold = (\n\t\t\t       SELECT s.transaction_id_sold FROM listing_sales s\n\t\t\t        WHERE s.signature = listings.signature\n\t\t\t          AND s.block_hash_listed = listings.block_hash_listed\n\t\t\t          AND s.longest_chain_sold = 1\n\t\t\t        ORDER BY s.block_id_sold DESC, s.id DESC\n\t\t\t        LIMIT 1\n\t\t\t     ),\n\t\t\t     longest_chain_sold = 1,\n\t\t\t     buyer = (\n\t\t\t       SELECT s.buyer FROM listing_sales s\n\t\t\t        WHERE s.signature = listings.signature\n\t\t\t          AND s.block_hash_listed = listings.block_hash_listed\n\t\t\t          AND s.longest_chain_sold = 1\n\t\t\t        ORDER BY s.block_id_sold DESC, s.id DESC\n\t\t\t        LIMIT 1\n\t\t\t     ),\n\t\t\t     note = (\n\t\t\t       SELECT s.note FROM listing_sales s\n\t\t\t        WHERE s.signature = listings.signature\n\t\t\t          AND s.block_hash_listed = listings.block_hash_listed\n\t\t\t          AND s.longest_chain_sold = 1\n\t\t\t        ORDER BY s.block_id_sold DESC, s.id DESC\n\t\t\t        LIMIT 1\n\t\t\t     ),\n\t\t\t     quantity_sold = (\n\t\t\t       SELECT s.quantity_sold FROM listing_sales s\n\t\t\t        WHERE s.signature = listings.signature\n\t\t\t          AND s.block_hash_listed = listings.block_hash_listed\n\t\t\t          AND s.longest_chain_sold = 1\n\t\t\t        ORDER BY s.block_id_sold DESC, s.id DESC\n\t\t\t        LIMIT 1\n\t\t\t     ),\n\t\t\t     sold_at = (\n\t\t\t       SELECT s.sold_at FROM listing_sales s\n\t\t\t        WHERE s.signature = listings.signature\n\t\t\t          AND s.block_hash_listed = listings.block_hash_listed\n\t\t\t          AND s.longest_chain_sold = 1\n\t\t\t        ORDER BY s.block_id_sold DESC, s.id DESC\n\t\t\t        LIMIT 1\n\t\t\t     ),\n\t\t\t     updated_at = $updated_at\n\t\t\t WHERE EXISTS (\n\t\t\t   SELECT 1 FROM listing_sales touched\n\t\t\t    WHERE touched.signature = listings.signature\n\t\t\t      AND touched.block_hash_listed = listings.block_hash_listed\n\t\t\t      AND touched.block_id_sold = $block_id\n\t\t\t      AND touched.block_hash_sold = $block_hash\n\t\t\t )\n\t\t\t AND EXISTS (\n\t\t\t   SELECT 1 FROM listing_sales canonical\n\t\t\t    WHERE canonical.signature = listings.signature\n\t\t\t      AND canonical.block_hash_listed = listings.block_hash_listed\n\t\t\t      AND canonical.longest_chain_sold = 1\n\t\t\t )", params);
            case 1:
              _context32.n = 2;
              return db.run("UPDATE listings\n\t\t\t SET longest_chain_sold = 0,\n\t\t\t     longest_chain_listed = -1,\n\t\t\t     updated_at = $updated_at\n\t\t\t WHERE EXISTS (\n\t\t\t   SELECT 1 FROM listing_sales touched\n\t\t\t    WHERE touched.signature = listings.signature\n\t\t\t      AND touched.block_hash_listed = listings.block_hash_listed\n\t\t\t      AND touched.block_id_sold = $block_id\n\t\t\t      AND touched.block_hash_sold = $block_hash\n\t\t\t )\n\t\t\t AND NOT EXISTS (\n\t\t\t   SELECT 1 FROM listing_sales canonical\n\t\t\t    WHERE canonical.signature = listings.signature\n\t\t\t      AND canonical.block_hash_listed = listings.block_hash_listed\n\t\t\t      AND canonical.longest_chain_sold = 1\n\t\t\t )", params);
            case 2:
              return _context32.a(2);
          }
        }, _callee31);
      }));
      function refreshSaleSnapshots(_x33, _x34) {
        return _refreshSaleSnapshots.apply(this, arguments);
      }
      return refreshSaleSnapshots;
    }()
  }, {
    key: "returnListingSalesForBlock",
    value: function () {
      var _returnListingSalesForBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee32(block_id, block_hash) {
        var _t26;
        return _regenerator().w(function (_context33) {
          while (1) switch (_context33.p = _context33.n) {
            case 0:
              _context33.p = 0;
              _context33.n = 1;
              return this.app.storage.queryDatabase("SELECT * FROM listing_sales\n\t\t\t\t WHERE block_id_sold = $block_id AND block_hash_sold = $block_hash", {
                $block_id: Number(block_id) || 0,
                $block_hash: String(block_hash || '')
              }, this.dbname);
            case 1:
              return _context33.a(2, _context33.v);
            case 2:
              _context33.p = 2;
              _t26 = _context33.v;
              return _context33.a(2, []);
          }
        }, _callee32, this, [[0, 2]]);
      }));
      function returnListingSalesForBlock(_x35, _x36) {
        return _returnListingSalesForBlock.apply(this, arguments);
      }
      return returnListingSalesForBlock;
    }()
  }, {
    key: "returnBucketsAffectedByBlock",
    value: function () {
      var _returnBucketsAffectedByBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee33(block_id, block_hash) {
        var _t27;
        return _regenerator().w(function (_context34) {
          while (1) switch (_context34.p = _context34.n) {
            case 0:
              _context34.p = 0;
              _context34.n = 1;
              return this.app.storage.queryDatabase("SELECT DISTINCT nft_id, price FROM listings\n\t\t\t\t WHERE (block_id_listed = $block_id AND block_hash_listed = $block_hash)\n\t\t\t\t    OR EXISTS (\n\t\t\t\t      SELECT 1 FROM listing_sales s\n\t\t\t\t       WHERE s.signature = listings.signature\n\t\t\t\t         AND s.block_hash_listed = listings.block_hash_listed\n\t\t\t\t         AND s.block_id_sold = $block_id\n\t\t\t\t         AND s.block_hash_sold = $block_hash\n\t\t\t\t    )", {
                $block_id: Number(block_id) || 0,
                $block_hash: String(block_hash || '')
              }, this.dbname);
            case 1:
              return _context34.a(2, _context34.v);
            case 2:
              _context34.p = 2;
              _t27 = _context34.v;
              return _context34.a(2, []);
          }
        }, _callee33, this, [[0, 2]]);
      }));
      function returnBucketsAffectedByBlock(_x37, _x38) {
        return _returnBucketsAffectedByBlock.apply(this, arguments);
      }
      return returnBucketsAffectedByBlock;
    }() // An NFT filter selects the cheapest available listing, oldest first on ties.
  }, {
    key: "returnActiveListingsForSeller",
    value: function () {
      var _returnActiveListingsForSeller = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee34() {
        var seller,
          nft_id,
          key,
          _args35 = arguments,
          _t28;
        return _regenerator().w(function (_context35) {
          while (1) switch (_context35.p = _context35.n) {
            case 0:
              seller = _args35.length > 0 && _args35[0] !== undefined ? _args35[0] : '';
              nft_id = _args35.length > 1 && _args35[1] !== undefined ? _args35[1] : '';
              key = String(seller || '').trim();
              if (key) {
                _context35.n = 1;
                break;
              }
              return _context35.a(2, []);
            case 1:
              _context35.p = 1;
              _context35.n = 2;
              return this.app.storage.queryDatabase("SELECT * FROM listings\n\t\t\t\t WHERE seller = $seller\n\t\t\t\t   AND ".concat(this.availableListingWhere(), "\n\t\t\t\t   ").concat(nft_id ? 'AND nft_id = $nft_id AND quantity > 0' : '', "\n\t\t\t\t ORDER BY ").concat(nft_id ? 'price ASC, created_at ASC, id ASC LIMIT 1' : 'created_at DESC'), nft_id ? {
                $seller: key,
                $nft_id: nft_id
              } : {
                $seller: key
              }, this.dbname);
            case 2:
              return _context35.a(2, _context35.v);
            case 3:
              _context35.p = 3;
              _t28 = _context35.v;
              return _context35.a(2, []);
          }
        }, _callee34, this, [[1, 3]]);
      }));
      function returnActiveListingsForSeller() {
        return _returnActiveListingsForSeller.apply(this, arguments);
      }
      return returnActiveListingsForSeller;
    }()
  }, {
    key: "sellerListingWhere",
    value: function sellerListingWhere() {
      var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'active';
      if (status === 'sold') {
        // Exclude seller-initiated delists (buyer set to seller as a self-sale).
        // Buyer is the snapshot of the canonical sale, refreshed with that sale.
        return "on_chain = 1\n\t\t\t\t   AND longest_chain_listed = 1\n\t\t\t\t   AND ".concat(this.canonicalSaleWhere(), "\n\t\t\t\t   AND buyer != ''\n\t\t\t\t   AND buyer != seller");
      }
      return this.availableListingWhere();
    }
  }, {
    key: "countPendingModerationListings",
    value: function () {
      var _countPendingModerationListings = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee35() {
        var _res$0$total, _res$3, res, _t29;
        return _regenerator().w(function (_context36) {
          while (1) switch (_context36.p = _context36.n) {
            case 0:
              _context36.p = 0;
              _context36.n = 1;
              return this.app.storage.queryDatabase("SELECT COUNT(*) AS total FROM listings\n\t\t\t\t WHERE ".concat(this.sellerListingWhere('active'), "\n\t\t\t\t   AND approved = 2"), {}, this.dbname);
            case 1:
              res = _context36.v;
              return _context36.a(2, Number((_res$0$total = res === null || res === void 0 || (_res$3 = res[0]) === null || _res$3 === void 0 ? void 0 : _res$3.total) !== null && _res$0$total !== void 0 ? _res$0$total : 0) || 0);
            case 2:
              _context36.p = 2;
              _t29 = _context36.v;
              return _context36.a(2, 0);
          }
        }, _callee35, this, [[0, 2]]);
      }));
      function countPendingModerationListings() {
        return _countPendingModerationListings.apply(this, arguments);
      }
      return countPendingModerationListings;
    }()
  }, {
    key: "moderationSortClause",
    value: function moderationSortClause() {
      var sort = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'created_at';
      var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'desc';
      var columns = {
        seller: 'listings.seller',
        title: "COALESCE(summary.title, '')",
        price: 'listings.price',
        created_at: 'listings.created_at',
        listed: 'listings.created_at',
        risk: "CASE listings.risk\n\t\t\t  WHEN 'Dangerous' THEN 4\n\t\t\t  WHEN 'High' THEN 3\n\t\t\t  WHEN 'Medium' THEN 2\n\t\t\t  WHEN 'Low' THEN 1\n\t\t\t  ELSE 0\n\t\t\tEND"
      };
      var column = columns[String(sort || '').trim()] || columns.created_at;
      var dir = String(direction || '').toLowerCase() === 'asc' ? 'ASC' : 'DESC';
      return "".concat(column, " ").concat(dir, ", listings.signature ASC");
    }
  }, {
    key: "returnPendingModerationPage",
    value: function () {
      var _returnPendingModerationPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee36() {
        var _ref8,
          _ref8$offset,
          offset,
          _ref8$page_size,
          page_size,
          _ref8$sort,
          sort,
          _ref8$direction,
          direction,
          params,
          order,
          _args37 = arguments,
          _t30;
        return _regenerator().w(function (_context37) {
          while (1) switch (_context37.p = _context37.n) {
            case 0:
              _ref8 = _args37.length > 0 && _args37[0] !== undefined ? _args37[0] : {}, _ref8$offset = _ref8.offset, offset = _ref8$offset === void 0 ? 0 : _ref8$offset, _ref8$page_size = _ref8.page_size, page_size = _ref8$page_size === void 0 ? 24 : _ref8$page_size, _ref8$sort = _ref8.sort, sort = _ref8$sort === void 0 ? 'created_at' : _ref8$sort, _ref8$direction = _ref8.direction, direction = _ref8$direction === void 0 ? 'desc' : _ref8$direction;
              params = {
                $limit: Math.max(1, Number(page_size) || 24),
                $offset: Math.max(0, Number(offset) || 0)
              };
              order = this.moderationSortClause(sort, direction);
              _context37.p = 1;
              _context37.n = 2;
              return this.app.storage.queryDatabase("SELECT listings.* FROM listings\n\t\t\t\t LEFT JOIN summary\n\t\t\t\t   ON summary.nft_id = listings.nft_id\n\t\t\t\t  AND summary.price = listings.price\n\t\t\t\t WHERE ".concat(this.sellerListingWhere('active'), "\n\t\t\t\t   AND listings.approved = 2\n\t\t\t\t ORDER BY ").concat(order, "\n\t\t\t\t LIMIT $limit OFFSET $offset"), params, this.dbname);
            case 2:
              return _context37.a(2, _context37.v);
            case 3:
              _context37.p = 3;
              _t30 = _context37.v;
              return _context37.a(2, []);
          }
        }, _callee36, this, [[1, 3]]);
      }));
      function returnPendingModerationPage() {
        return _returnPendingModerationPage.apply(this, arguments);
      }
      return returnPendingModerationPage;
    }()
    /**
     * Moderator action: 2 → 1 (approve) or 2 → -1 (reject).
     * No-op / fail if the row is no longer pending.
     * Decided on the canonical inclusion but written to every inclusion of the same
     * transaction, so the decision survives a reorg back onto another inclusion.
     */
  }, {
    key: "moderatePendingListing",
    value: function () {
      var _moderatePendingListing = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee37(signature) {
        var _row$approved2, _updated$approved;
        var action,
          sig,
          next,
          row,
          _row$approved3,
          updated,
          approved,
          _args38 = arguments;
        return _regenerator().w(function (_context38) {
          while (1) switch (_context38.n) {
            case 0:
              action = _args38.length > 1 && _args38[1] !== undefined ? _args38[1] : '';
              sig = String(signature || '').trim();
              next = String(action || '').toLowerCase() === 'reject' ? -1 : 1;
              if (sig) {
                _context38.n = 1;
                break;
              }
              return _context38.a(2, {
                ok: false,
                err: 'Listing signature required'
              });
            case 1:
              _context38.n = 2;
              return this.returnCanonicalListingBySignature(sig);
            case 2:
              row = _context38.v;
              if (row) {
                _context38.n = 3;
                break;
              }
              return _context38.a(2, {
                ok: false,
                err: 'Listing not found'
              });
            case 3:
              if (!(Number((_row$approved2 = row.approved) !== null && _row$approved2 !== void 0 ? _row$approved2 : 0) !== 2)) {
                _context38.n = 4;
                break;
              }
              return _context38.a(2, {
                ok: false,
                err: 'No longer pending',
                approved: Number((_row$approved3 = row.approved) !== null && _row$approved3 !== void 0 ? _row$approved3 : 0)
              });
            case 4:
              _context38.n = 5;
              return this.app.storage.runDatabase("UPDATE listings SET approved = $approved\n\t\t\t WHERE signature = $signature AND approved = 2", {
                $signature: sig,
                $approved: next
              }, this.dbname);
            case 5:
              _context38.n = 6;
              return this.returnCanonicalListingBySignature(sig);
            case 6:
              updated = _context38.v;
              approved = Number((_updated$approved = updated === null || updated === void 0 ? void 0 : updated.approved) !== null && _updated$approved !== void 0 ? _updated$approved : 0);
              if (!(approved !== next)) {
                _context38.n = 7;
                break;
              }
              return _context38.a(2, {
                ok: false,
                err: 'No longer pending',
                approved: approved
              });
            case 7:
              return _context38.a(2, {
                ok: true,
                approved: approved
              });
          }
        }, _callee37, this);
      }));
      function moderatePendingListing(_x39) {
        return _moderatePendingListing.apply(this, arguments);
      }
      return moderatePendingListing;
    }()
    /**
     * Main Store eligibility: active listing AND (seller IN whitelist OR approved = 1).
     * Empty whitelist is valid — approved listings still qualify.
     */
  }, {
    key: "marketplaceEligibilityClause",
    value: function marketplaceEligibilityClause() {
      var whitelist_sellers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var keys = _toConsumableArray(new Set((Array.isArray(whitelist_sellers) ? whitelist_sellers : []).map(function (key) {
        return String(key || '').trim();
      }).filter(Boolean)));
      var params = {};
      if (!keys.length) {
        return {
          sql: 'approved = 1',
          params: params
        };
      }
      var placeholders = keys.map(function (key, i) {
        var name = "$seller_".concat(i);
        params[name] = key;
        return name;
      });
      return {
        sql: "(seller IN (".concat(placeholders.join(', '), ") OR approved = 1)"),
        params: params
      };
    }
  }, {
    key: "setListingApproved",
    value: function () {
      var _setListingApproved = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee38(signature, approved) {
        var _row$approved4;
        var sig, flag, row;
        return _regenerator().w(function (_context39) {
          while (1) switch (_context39.n) {
            case 0:
              sig = String(signature || '').trim();
              if (sig) {
                _context39.n = 1;
                break;
              }
              return _context39.a(2, false);
            case 1:
              flag = approved ? 1 : 0;
              _context39.n = 2;
              return this.app.storage.runDatabase("UPDATE listings SET approved = $approved WHERE signature = $signature", {
                $signature: sig,
                $approved: flag
              }, this.dbname);
            case 2:
              _context39.n = 3;
              return this.returnCanonicalListingBySignature(sig);
            case 3:
              row = _context39.v;
              return _context39.a(2, Number((_row$approved4 = row === null || row === void 0 ? void 0 : row.approved) !== null && _row$approved4 !== void 0 ? _row$approved4 : 0) === flag);
          }
        }, _callee38, this);
      }));
      function setListingApproved(_x40, _x41) {
        return _setListingApproved.apply(this, arguments);
      }
      return setListingApproved;
    }()
    /**
     * Seller submission: 0 → 2, -1 → 2. Already pending/approved is a no-op.
     * Never writes 1 or -1.
     */
  }, {
    key: "submitListingForMainStore",
    value: function () {
      var _submitListingForMainStore = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee39(signature) {
        var _row$approved5, _updated$approved2;
        var sig, row, current, updated, next;
        return _regenerator().w(function (_context40) {
          while (1) switch (_context40.n) {
            case 0:
              sig = String(signature || '').trim();
              if (sig) {
                _context40.n = 1;
                break;
              }
              return _context40.a(2, {
                ok: false,
                err: 'Listing signature required'
              });
            case 1:
              _context40.n = 2;
              return this.returnCanonicalListingBySignature(sig);
            case 2:
              row = _context40.v;
              if (row) {
                _context40.n = 3;
                break;
              }
              return _context40.a(2, {
                ok: false,
                err: 'Listing not found'
              });
            case 3:
              current = Number((_row$approved5 = row.approved) !== null && _row$approved5 !== void 0 ? _row$approved5 : 0);
              if (!(current === 1 || current === 2)) {
                _context40.n = 4;
                break;
              }
              return _context40.a(2, {
                ok: true,
                approved: current,
                unchanged: true
              });
            case 4:
              if (!(current !== 0 && current !== -1)) {
                _context40.n = 5;
                break;
              }
              return _context40.a(2, {
                ok: false,
                err: 'Unable to submit listing'
              });
            case 5:
              _context40.n = 6;
              return this.app.storage.runDatabase("UPDATE listings SET approved = 2 WHERE signature = $signature AND approved IN (0, -1)", {
                $signature: sig
              }, this.dbname);
            case 6:
              _context40.n = 7;
              return this.returnCanonicalListingBySignature(sig);
            case 7:
              updated = _context40.v;
              next = Number((_updated$approved2 = updated === null || updated === void 0 ? void 0 : updated.approved) !== null && _updated$approved2 !== void 0 ? _updated$approved2 : 0);
              if (!(next === 2)) {
                _context40.n = 8;
                break;
              }
              return _context40.a(2, {
                ok: true,
                approved: 2
              });
            case 8:
              if (!(next === 1)) {
                _context40.n = 9;
                break;
              }
              return _context40.a(2, {
                ok: true,
                approved: 1,
                unchanged: true
              });
            case 9:
              return _context40.a(2, {
                ok: false,
                err: 'Unable to submit listing'
              });
          }
        }, _callee39, this);
      }));
      function submitListingForMainStore(_x42) {
        return _submitListingForMainStore.apply(this, arguments);
      }
      return submitListingForMainStore;
    }()
  }, {
    key: "countMarketplaceListings",
    value: function () {
      var _countMarketplaceListings = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee40() {
        var _ref9,
          _ref9$whitelist_selle,
          whitelist_sellers,
          _ref9$category,
          category,
          filter,
          eligibility,
          params,
          category_sql,
          _res$0$total2,
          _res$4,
          res,
          _args41 = arguments,
          _t31;
        return _regenerator().w(function (_context41) {
          while (1) switch (_context41.p = _context41.n) {
            case 0:
              _ref9 = _args41.length > 0 && _args41[0] !== undefined ? _args41[0] : {}, _ref9$whitelist_selle = _ref9.whitelist_sellers, whitelist_sellers = _ref9$whitelist_selle === void 0 ? [] : _ref9$whitelist_selle, _ref9$category = _ref9.category, category = _ref9$category === void 0 ? '' : _ref9$category;
              filter = String(category || '').trim();
              eligibility = this.marketplaceEligibilityClause(whitelist_sellers);
              params = _objectSpread({}, eligibility.params);
              category_sql = '';
              if (filter) {
                category_sql = ' AND category = $category';
                params.$category = filter;
              }
              _context41.p = 1;
              _context41.n = 2;
              return this.app.storage.queryDatabase("SELECT COUNT(*) AS total FROM listings\n\t\t\t\t WHERE ".concat(this.sellerListingWhere('active'), "\n\t\t\t\t   AND ").concat(eligibility.sql).concat(category_sql), params, this.dbname);
            case 2:
              res = _context41.v;
              return _context41.a(2, Number((_res$0$total2 = res === null || res === void 0 || (_res$4 = res[0]) === null || _res$4 === void 0 ? void 0 : _res$4.total) !== null && _res$0$total2 !== void 0 ? _res$0$total2 : 0) || 0);
            case 3:
              _context41.p = 3;
              _t31 = _context41.v;
              return _context41.a(2, 0);
          }
        }, _callee40, this, [[1, 3]]);
      }));
      function countMarketplaceListings() {
        return _countMarketplaceListings.apply(this, arguments);
      }
      return countMarketplaceListings;
    }()
  }, {
    key: "returnMarketplaceListingsPage",
    value: function () {
      var _returnMarketplaceListingsPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee41() {
        var _ref0,
          _ref0$whitelist_selle,
          whitelist_sellers,
          _ref0$category,
          category,
          _ref0$offset,
          offset,
          _ref0$page_size,
          page_size,
          filter,
          eligibility,
          params,
          category_sql,
          _args42 = arguments,
          _t32;
        return _regenerator().w(function (_context42) {
          while (1) switch (_context42.p = _context42.n) {
            case 0:
              _ref0 = _args42.length > 0 && _args42[0] !== undefined ? _args42[0] : {}, _ref0$whitelist_selle = _ref0.whitelist_sellers, whitelist_sellers = _ref0$whitelist_selle === void 0 ? [] : _ref0$whitelist_selle, _ref0$category = _ref0.category, category = _ref0$category === void 0 ? '' : _ref0$category, _ref0$offset = _ref0.offset, offset = _ref0$offset === void 0 ? 0 : _ref0$offset, _ref0$page_size = _ref0.page_size, page_size = _ref0$page_size === void 0 ? 24 : _ref0$page_size;
              filter = String(category || '').trim();
              eligibility = this.marketplaceEligibilityClause(whitelist_sellers);
              params = _objectSpread(_objectSpread({}, eligibility.params), {}, {
                $limit: Math.max(1, Number(page_size) || 24),
                $offset: Math.max(0, Number(offset) || 0)
              });
              category_sql = '';
              if (filter) {
                category_sql = ' AND category = $category';
                params.$category = filter;
              }
              _context42.p = 1;
              _context42.n = 2;
              return this.app.storage.queryDatabase("SELECT * FROM listings\n\t\t\t\t WHERE ".concat(this.sellerListingWhere('active'), "\n\t\t\t\t   AND ").concat(eligibility.sql).concat(category_sql, "\n\t\t\t\t ORDER BY CASE WHEN updated_at > 0 THEN updated_at ELSE created_at END DESC, signature ASC\n\t\t\t\t LIMIT $limit OFFSET $offset"), params, this.dbname);
            case 2:
              return _context42.a(2, _context42.v);
            case 3:
              _context42.p = 3;
              _t32 = _context42.v;
              return _context42.a(2, []);
          }
        }, _callee41, this, [[1, 3]]);
      }));
      function returnMarketplaceListingsPage() {
        return _returnMarketplaceListingsPage.apply(this, arguments);
      }
      return returnMarketplaceListingsPage;
    }()
  }, {
    key: "countListingsForSeller",
    value: function () {
      var _countListingsForSeller = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee42() {
        var _ref1,
          _ref1$seller,
          seller,
          _ref1$status,
          status,
          _ref1$category,
          category,
          key,
          filter,
          params,
          category_sql,
          _res$0$total3,
          _res$5,
          res,
          _args43 = arguments,
          _t33;
        return _regenerator().w(function (_context43) {
          while (1) switch (_context43.p = _context43.n) {
            case 0:
              _ref1 = _args43.length > 0 && _args43[0] !== undefined ? _args43[0] : {}, _ref1$seller = _ref1.seller, seller = _ref1$seller === void 0 ? '' : _ref1$seller, _ref1$status = _ref1.status, status = _ref1$status === void 0 ? 'active' : _ref1$status, _ref1$category = _ref1.category, category = _ref1$category === void 0 ? '' : _ref1$category;
              key = String(seller || '').trim();
              if (key) {
                _context43.n = 1;
                break;
              }
              return _context43.a(2, 0);
            case 1:
              filter = String(category || '').trim();
              params = {
                $seller: key
              };
              category_sql = '';
              if (filter) {
                category_sql = ' AND category = $category';
                params.$category = filter;
              }
              _context43.p = 2;
              _context43.n = 3;
              return this.app.storage.queryDatabase("SELECT COUNT(*) AS total FROM listings\n\t\t\t\t WHERE seller = $seller\n\t\t\t\t   AND ".concat(this.sellerListingWhere(status)).concat(category_sql), params, this.dbname);
            case 3:
              res = _context43.v;
              return _context43.a(2, Number((_res$0$total3 = res === null || res === void 0 || (_res$5 = res[0]) === null || _res$5 === void 0 ? void 0 : _res$5.total) !== null && _res$0$total3 !== void 0 ? _res$0$total3 : 0) || 0);
            case 4:
              _context43.p = 4;
              _t33 = _context43.v;
              return _context43.a(2, 0);
          }
        }, _callee42, this, [[2, 4]]);
      }));
      function countListingsForSeller() {
        return _countListingsForSeller.apply(this, arguments);
      }
      return countListingsForSeller;
    }()
  }, {
    key: "returnListingsPageForSeller",
    value: function () {
      var _returnListingsPageForSeller = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee43() {
        var _ref10,
          _ref10$seller,
          seller,
          _ref10$status,
          status,
          _ref10$category,
          category,
          _ref10$offset,
          offset,
          _ref10$page_size,
          page_size,
          key,
          filter,
          params,
          category_sql,
          order_sql,
          _args44 = arguments,
          _t34;
        return _regenerator().w(function (_context44) {
          while (1) switch (_context44.p = _context44.n) {
            case 0:
              _ref10 = _args44.length > 0 && _args44[0] !== undefined ? _args44[0] : {}, _ref10$seller = _ref10.seller, seller = _ref10$seller === void 0 ? '' : _ref10$seller, _ref10$status = _ref10.status, status = _ref10$status === void 0 ? 'active' : _ref10$status, _ref10$category = _ref10.category, category = _ref10$category === void 0 ? '' : _ref10$category, _ref10$offset = _ref10.offset, offset = _ref10$offset === void 0 ? 0 : _ref10$offset, _ref10$page_size = _ref10.page_size, page_size = _ref10$page_size === void 0 ? 24 : _ref10$page_size;
              key = String(seller || '').trim();
              if (key) {
                _context44.n = 1;
                break;
              }
              return _context44.a(2, []);
            case 1:
              filter = String(category || '').trim();
              params = {
                $seller: key,
                $limit: Math.max(1, Number(page_size) || 24),
                $offset: Math.max(0, Number(offset) || 0)
              };
              category_sql = '';
              if (filter) {
                category_sql = ' AND category = $category';
                params.$category = filter;
              }
              _context44.p = 2;
              order_sql = status === 'sold' ? 'CASE WHEN sold_at > 0 THEN sold_at ELSE updated_at END DESC, block_id_sold DESC, signature ASC' : 'created_at DESC, signature ASC';
              _context44.n = 3;
              return this.app.storage.queryDatabase("SELECT * FROM listings\n\t\t\t\t WHERE seller = $seller\n\t\t\t\t   AND ".concat(this.sellerListingWhere(status)).concat(category_sql, "\n\t\t\t\t ORDER BY ").concat(order_sql, "\n\t\t\t\t LIMIT $limit OFFSET $offset"), params, this.dbname);
            case 3:
              return _context44.a(2, _context44.v);
            case 4:
              _context44.p = 4;
              _t34 = _context44.v;
              return _context44.a(2, []);
          }
        }, _callee43, this, [[2, 4]]);
      }));
      function returnListingsPageForSeller() {
        return _returnListingsPageForSeller.apply(this, arguments);
      }
      return returnListingsPageForSeller;
    }()
  }, {
    key: "returnSoldListingsForSeller",
    value: function () {
      var _returnSoldListingsForSeller = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee44() {
        var seller,
          key,
          _args45 = arguments,
          _t35;
        return _regenerator().w(function (_context45) {
          while (1) switch (_context45.p = _context45.n) {
            case 0:
              seller = _args45.length > 0 && _args45[0] !== undefined ? _args45[0] : '';
              key = String(seller || '').trim();
              if (key) {
                _context45.n = 1;
                break;
              }
              return _context45.a(2, []);
            case 1:
              _context45.p = 1;
              _context45.n = 2;
              return this.app.storage.queryDatabase("SELECT * FROM listings\n\t\t\t\t WHERE seller = $seller\n\t\t\t\t   AND ".concat(this.sellerListingWhere('sold'), "\n\t\t\t\t ORDER BY CASE WHEN sold_at > 0 THEN sold_at ELSE updated_at END DESC, block_id_sold DESC, signature ASC"), {
                $seller: key
              }, this.dbname);
            case 2:
              return _context45.a(2, _context45.v);
            case 3:
              _context45.p = 3;
              _t35 = _context45.v;
              return _context45.a(2, []);
          }
        }, _callee44, this, [[1, 3]]);
      }));
      function returnSoldListingsForSeller() {
        return _returnSoldListingsForSeller.apply(this, arguments);
      }
      return returnSoldListingsForSeller;
    }()
  }, {
    key: "scanListingsForSummaryRebuild",
    value: function () {
      var _scanListingsForSummaryRebuild = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee45() {
        var _t36;
        return _regenerator().w(function (_context46) {
          while (1) switch (_context46.p = _context46.n) {
            case 0:
              _context46.p = 0;
              _context46.n = 1;
              return this.app.storage.queryDatabase("SELECT nft_id, price, SUM(quantity) AS total_quantity\n\t\t\t\t FROM listings\n\t\t\t\t WHERE ".concat(this.availableListingWhere(), "\n\t\t\t\t GROUP BY nft_id, price"), {}, this.dbname);
            case 1:
              return _context46.a(2, _context46.v);
            case 2:
              _context46.p = 2;
              _t36 = _context46.v;
              console.log('Store Database: scanListingsForSummaryRebuild failed', _t36 === null || _t36 === void 0 ? void 0 : _t36.message);
              return _context46.a(2, []);
          }
        }, _callee45, this, [[0, 2]]);
      }));
      function scanListingsForSummaryRebuild() {
        return _scanListingsForSummaryRebuild.apply(this, arguments);
      }
      return scanListingsForSummaryRebuild;
    }() // --- summary (derived market aggregate) ---
  }, {
    key: "insertSummary",
    value: function () {
      var _insertSummary = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee46(summary) {
        var _summary$price, _summary$image, _summary$quantity_ava, _summary$updated_at;
        var sql, params, db;
        return _regenerator().w(function (_context47) {
          while (1) switch (_context47.n) {
            case 0:
              sql = "INSERT INTO summary (\n\t\t\t  nft_id, price, web3_ticker, web3_amount, category, title, description, image,\n\t\t\t  quantity_available, updated_at\n\t\t\t) VALUES (\n\t\t\t  $nft_id, $price, $web3_ticker, $web3_amount, $category, $title, $description, $image,\n\t\t\t  $quantity_available, $updated_at\n\t\t\t)";
              params = {
                $nft_id: summary.nft_id,
                $price: Number((_summary$price = summary.price) !== null && _summary$price !== void 0 ? _summary$price : 0),
                $web3_ticker: String(summary.web3_ticker || '').trim().toUpperCase(),
                $web3_amount: String(summary.web3_amount || '').trim(),
                $category: summary.category || STORE_CATEGORIES.OTHER,
                $title: summary.title || '',
                $description: summary.description || '',
                $image: (_summary$image = summary.image) !== null && _summary$image !== void 0 ? _summary$image : null,
                $quantity_available: Number((_summary$quantity_ava = summary.quantity_available) !== null && _summary$quantity_ava !== void 0 ? _summary$quantity_ava : 0),
                $updated_at: (_summary$updated_at = summary.updated_at) !== null && _summary$updated_at !== void 0 ? _summary$updated_at : Date.now()
              }; // Bypass runDatabase so insert failures surface (runDatabase swallows errors).
              _context47.n = 1;
              return this.app.storage.returnDatabaseByName(this.dbname);
            case 1:
              db = _context47.v;
              if (db) {
                _context47.n = 2;
                break;
              }
              throw new Error('Store database unavailable');
            case 2:
              _context47.n = 3;
              return db.run(sql, params);
            case 3:
              return _context47.a(2);
          }
        }, _callee46, this);
      }));
      function insertSummary(_x43) {
        return _insertSummary.apply(this, arguments);
      }
      return insertSummary;
    }()
  }, {
    key: "updateSummaryWeb3",
    value: function () {
      var _updateSummaryWeb = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee47(nft_id, price) {
        var _ref11,
          _ref11$web3_ticker,
          web3_ticker,
          _ref11$web3_amount,
          web3_amount,
          _args48 = arguments;
        return _regenerator().w(function (_context48) {
          while (1) switch (_context48.n) {
            case 0:
              _ref11 = _args48.length > 2 && _args48[2] !== undefined ? _args48[2] : {}, _ref11$web3_ticker = _ref11.web3_ticker, web3_ticker = _ref11$web3_ticker === void 0 ? '' : _ref11$web3_ticker, _ref11$web3_amount = _ref11.web3_amount, web3_amount = _ref11$web3_amount === void 0 ? '' : _ref11$web3_amount;
              _context48.n = 1;
              return this.app.storage.runDatabase("UPDATE summary\n\t\t\t    SET web3_ticker = $web3_ticker, web3_amount = $web3_amount\n\t\t\t  WHERE nft_id = $nft_id AND price = $price", {
                $nft_id: nft_id,
                $price: Number(price !== null && price !== void 0 ? price : 0),
                $web3_ticker: String(web3_ticker || '').trim().toUpperCase(),
                $web3_amount: String(web3_amount || '').trim()
              }, this.dbname);
            case 1:
              return _context48.a(2);
          }
        }, _callee47, this);
      }));
      function updateSummaryWeb3(_x44, _x45) {
        return _updateSummaryWeb.apply(this, arguments);
      }
      return updateSummaryWeb3;
    }()
  }, {
    key: "returnSummary",
    value: function () {
      var _returnSummary = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee48(summary_id) {
        var res;
        return _regenerator().w(function (_context49) {
          while (1) switch (_context49.n) {
            case 0:
              _context49.n = 1;
              return this.app.storage.queryDatabase("SELECT * FROM summary WHERE id = $id LIMIT 1", {
                $id: Number(summary_id)
              }, this.dbname);
            case 1:
              res = _context49.v;
              return _context49.a(2, (res === null || res === void 0 ? void 0 : res[0]) || null);
          }
        }, _callee48, this);
      }));
      function returnSummary(_x46) {
        return _returnSummary.apply(this, arguments);
      }
      return returnSummary;
    }()
  }, {
    key: "returnSummaryByBucket",
    value: function () {
      var _returnSummaryByBucket = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee49(nft_id, price) {
        var res;
        return _regenerator().w(function (_context50) {
          while (1) switch (_context50.n) {
            case 0:
              _context50.n = 1;
              return this.app.storage.queryDatabase("SELECT * FROM summary WHERE nft_id = $nft_id AND price = $price LIMIT 1", {
                $nft_id: nft_id,
                $price: Number(price)
              }, this.dbname);
            case 1:
              res = _context50.v;
              return _context50.a(2, (res === null || res === void 0 ? void 0 : res[0]) || null);
          }
        }, _callee49, this);
      }));
      function returnSummaryByBucket(_x47, _x48) {
        return _returnSummaryByBucket.apply(this, arguments);
      }
      return returnSummaryByBucket;
    }()
  }, {
    key: "loadAllSummaries",
    value: function () {
      var _loadAllSummaries = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee50() {
        var _t37;
        return _regenerator().w(function (_context51) {
          while (1) switch (_context51.p = _context51.n) {
            case 0:
              _context51.p = 0;
              _context51.n = 1;
              return this.app.storage.queryDatabase("SELECT * FROM summary", {}, this.dbname);
            case 1:
              return _context51.a(2, _context51.v);
            case 2:
              _context51.p = 2;
              _t37 = _context51.v;
              return _context51.a(2, []);
          }
        }, _callee50, this, [[0, 2]]);
      }));
      function loadAllSummaries() {
        return _loadAllSummaries.apply(this, arguments);
      }
      return loadAllSummaries;
    }()
  }, {
    key: "clearSummaries",
    value: function () {
      var _clearSummaries = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee51() {
        return _regenerator().w(function (_context52) {
          while (1) switch (_context52.n) {
            case 0:
              _context52.n = 1;
              return this.app.storage.runDatabase("DELETE FROM summary", {}, this.dbname);
            case 1:
              return _context52.a(2);
          }
        }, _callee51, this);
      }));
      function clearSummaries() {
        return _clearSummaries.apply(this, arguments);
      }
      return clearSummaries;
    }()
    /**
     * Atomically replace the entire summary table (DELETE + INSERTs).
     * Uses the shared SQLite connection's BEGIN/COMMIT so readers on this
     * connection never observe a half-rebuilt table if the rebuild fails.
     */
  }, {
    key: "replaceAllSummaries",
    value: function () {
      var _replaceAllSummaries = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee52() {
        var rows,
          db,
          insert_sql,
          _iterator7,
          _step7,
          _summary$price2,
          _summary$image2,
          _summary$quantity_ava2,
          _summary$updated_at2,
          summary,
          _args53 = arguments,
          _t38,
          _t39,
          _t40;
        return _regenerator().w(function (_context53) {
          while (1) switch (_context53.p = _context53.n) {
            case 0:
              rows = _args53.length > 0 && _args53[0] !== undefined ? _args53[0] : [];
              _context53.n = 1;
              return this.app.storage.returnDatabaseByName(this.dbname);
            case 1:
              db = _context53.v;
              if (db) {
                _context53.n = 2;
                break;
              }
              throw new Error('Store database unavailable');
            case 2:
              insert_sql = "INSERT INTO summary (\n\t\t\t  nft_id, price, category, title, description, image,\n\t\t\t  quantity_available, updated_at\n\t\t\t) VALUES (\n\t\t\t  $nft_id, $price, $category, $title, $description, $image,\n\t\t\t  $quantity_available, $updated_at\n\t\t\t)";
              _context53.n = 3;
              return db.exec('BEGIN IMMEDIATE');
            case 3:
              _context53.p = 3;
              _context53.n = 4;
              return db.run("DELETE FROM summary");
            case 4:
              _iterator7 = _createForOfIteratorHelper(rows || []);
              _context53.p = 5;
              _iterator7.s();
            case 6:
              if ((_step7 = _iterator7.n()).done) {
                _context53.n = 8;
                break;
              }
              summary = _step7.value;
              _context53.n = 7;
              return db.run(insert_sql, {
                $nft_id: summary.nft_id,
                $price: Number((_summary$price2 = summary.price) !== null && _summary$price2 !== void 0 ? _summary$price2 : 0),
                $category: summary.category || STORE_CATEGORIES.OTHER,
                $title: summary.title || '',
                $description: summary.description || '',
                $image: (_summary$image2 = summary.image) !== null && _summary$image2 !== void 0 ? _summary$image2 : null,
                $quantity_available: Number((_summary$quantity_ava2 = summary.quantity_available) !== null && _summary$quantity_ava2 !== void 0 ? _summary$quantity_ava2 : 0),
                $updated_at: (_summary$updated_at2 = summary.updated_at) !== null && _summary$updated_at2 !== void 0 ? _summary$updated_at2 : Date.now()
              });
            case 7:
              _context53.n = 6;
              break;
            case 8:
              _context53.n = 10;
              break;
            case 9:
              _context53.p = 9;
              _t38 = _context53.v;
              _iterator7.e(_t38);
            case 10:
              _context53.p = 10;
              _iterator7.f();
              return _context53.f(10);
            case 11:
              _context53.n = 12;
              return db.exec('COMMIT');
            case 12:
              _context53.n = 18;
              break;
            case 13:
              _context53.p = 13;
              _t39 = _context53.v;
              _context53.p = 14;
              _context53.n = 15;
              return db.exec('ROLLBACK');
            case 15:
              _context53.n = 17;
              break;
            case 16:
              _context53.p = 16;
              _t40 = _context53.v;
            case 17:
              throw _t39;
            case 18:
              return _context53.a(2);
          }
        }, _callee52, this, [[14, 16], [5, 9, 10, 11], [3, 13]]);
      }));
      function replaceAllSummaries() {
        return _replaceAllSummaries.apply(this, arguments);
      }
      return replaceAllSummaries;
    }()
  }, {
    key: "deleteSummaryByBucket",
    value: function () {
      var _deleteSummaryByBucket = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee53(nft_id, price) {
        return _regenerator().w(function (_context54) {
          while (1) switch (_context54.n) {
            case 0:
              _context54.n = 1;
              return this.app.storage.runDatabase("DELETE FROM summary WHERE nft_id = $nft_id AND price = $price", {
                $nft_id: nft_id,
                $price: Number(price)
              }, this.dbname);
            case 1:
              return _context54.a(2);
          }
        }, _callee53, this);
      }));
      function deleteSummaryByBucket(_x49, _x50) {
        return _deleteSummaryByBucket.apply(this, arguments);
      }
      return deleteSummaryByBucket;
    }()
  }, {
    key: "updateSummaryAvailableByBucket",
    value: function () {
      var _updateSummaryAvailableByBucket = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee54(nft_id, price, quantity_available) {
        var now,
          _args55 = arguments;
        return _regenerator().w(function (_context55) {
          while (1) switch (_context55.n) {
            case 0:
              now = _args55.length > 3 && _args55[3] !== undefined ? _args55[3] : Date.now();
              _context55.n = 1;
              return this.app.storage.runDatabase("UPDATE summary\n\t\t\t SET quantity_available = $quantity_available,\n\t\t\t     updated_at = $updated_at\n\t\t\t WHERE nft_id = $nft_id AND price = $price", {
                $nft_id: nft_id,
                $price: Number(price),
                $quantity_available: Number(quantity_available !== null && quantity_available !== void 0 ? quantity_available : 0),
                $updated_at: now
              }, this.dbname);
            case 1:
              return _context55.a(2);
          }
        }, _callee54, this);
      }));
      function updateSummaryAvailableByBucket(_x51, _x52, _x53) {
        return _updateSummaryAvailableByBucket.apply(this, arguments);
      }
      return updateSummaryAvailableByBucket;
    }()
  }, {
    key: "updateSummaryMetadata",
    value: function () {
      var _updateSummaryMetadata = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee55(nft_id, price) {
        var _ref12,
          _ref12$title,
          title,
          _ref12$description,
          description,
          _args56 = arguments;
        return _regenerator().w(function (_context56) {
          while (1) switch (_context56.n) {
            case 0:
              _ref12 = _args56.length > 2 && _args56[2] !== undefined ? _args56[2] : {}, _ref12$title = _ref12.title, title = _ref12$title === void 0 ? '' : _ref12$title, _ref12$description = _ref12.description, description = _ref12$description === void 0 ? '' : _ref12$description;
              _context56.n = 1;
              return this.app.storage.runDatabase("UPDATE summary\n\t\t\t SET title = CASE WHEN length($title) > 0 THEN $title ELSE title END,\n\t\t\t     description = CASE WHEN length($description) > 0 THEN $description ELSE description END,\n\t\t\t     updated_at = $updated_at\n\t\t\t WHERE nft_id = $nft_id AND price = $price", {
                $nft_id: nft_id,
                $price: Number(price !== null && price !== void 0 ? price : 0),
                $title: String(title || ''),
                $description: String(description || ''),
                $updated_at: Date.now()
              }, this.dbname);
            case 1:
              return _context56.a(2);
          }
        }, _callee55, this);
      }));
      function updateSummaryMetadata(_x54, _x55) {
        return _updateSummaryMetadata.apply(this, arguments);
      }
      return updateSummaryMetadata;
    }()
  }, {
    key: "updateSummaryCategory",
    value: function () {
      var _updateSummaryCategory = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee56(nft_id, price) {
        var category,
          _args57 = arguments;
        return _regenerator().w(function (_context57) {
          while (1) switch (_context57.n) {
            case 0:
              category = _args57.length > 2 && _args57[2] !== undefined ? _args57[2] : STORE_CATEGORIES.OTHER;
              _context57.n = 1;
              return this.app.storage.runDatabase("UPDATE summary\n\t\t\t SET category = $category,\n\t\t\t     updated_at = $updated_at\n\t\t\t WHERE nft_id = $nft_id AND price = $price", {
                $nft_id: nft_id,
                $price: Number(price !== null && price !== void 0 ? price : 0),
                $category: String(category || STORE_CATEGORIES.OTHER),
                $updated_at: Date.now()
              }, this.dbname);
            case 1:
              return _context57.a(2);
          }
        }, _callee56, this);
      }));
      function updateSummaryCategory(_x56, _x57) {
        return _updateSummaryCategory.apply(this, arguments);
      }
      return updateSummaryCategory;
    }() // --- orders ---
  }, {
    key: "insertOrder",
    value: function () {
      var _insertOrder = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee57(order) {
        var _res$changes;
        var res;
        return _regenerator().w(function (_context58) {
          while (1) switch (_context58.n) {
            case 0:
              _context58.n = 1;
              return this.app.storage.runDatabase("INSERT OR IGNORE INTO orders (\n\t\t\t  order_tx_sig, buyer, nft_id, price, quantity, note,\n\t\t\t  payment_tx_sig, payment_output_index, payment_amount, utxo_slip,\n\t\t\t  access_hash, access_script, p2sh_address,\n\t\t\t  block_id_received, block_hash_received, transaction_id_received, longest_chain_received,\n\t\t\t  settlement_tx_sig,\n\t\t\t  block_id_fulfilled, block_hash_fulfilled, transaction_id_fulfilled, longest_chain_fulfilled,\n\t\t\t  attempts, status,\n\t\t\t  created_at, updated_at\n\t\t\t) VALUES (\n\t\t\t  $order_tx_sig, $buyer, $nft_id, $price, $quantity, $note,\n\t\t\t  $payment_tx_sig, $payment_output_index, $payment_amount, $utxo_slip,\n\t\t\t  $access_hash, $access_script, $p2sh_address,\n\t\t\t  $block_id_received, $block_hash_received, $transaction_id_received, $longest_chain_received,\n\t\t\t  $settlement_tx_sig,\n\t\t\t  $block_id_fulfilled, $block_hash_fulfilled, $transaction_id_fulfilled, $longest_chain_fulfilled,\n\t\t\t  $attempts, $status,\n\t\t\t  $created_at, $updated_at\n\t\t\t)", order, this.dbname);
            case 1:
              res = _context58.v;
              return _context58.a(2, Number((_res$changes = res === null || res === void 0 ? void 0 : res.changes) !== null && _res$changes !== void 0 ? _res$changes : 0));
          }
        }, _callee57, this);
      }));
      function insertOrder(_x58) {
        return _insertOrder.apply(this, arguments);
      }
      return insertOrder;
    }()
  }, {
    key: "updateOrder",
    value: function () {
      var _updateOrder = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee58(order_id) {
        var fields,
          now,
          allowed,
          sets,
          params,
          _i6,
          _allowed,
          key,
          _args59 = arguments;
        return _regenerator().w(function (_context59) {
          while (1) switch (_context59.n) {
            case 0:
              fields = _args59.length > 1 && _args59[1] !== undefined ? _args59[1] : {};
              now = _args59.length > 2 && _args59[2] !== undefined ? _args59[2] : Date.now();
              allowed = ['settlement_tx_sig', 'block_id_fulfilled', 'block_hash_fulfilled', 'transaction_id_fulfilled', 'longest_chain_fulfilled', 'longest_chain_received', 'attempts', 'status'];
              sets = [];
              params = {
                $id: Number(order_id),
                $updated_at: now
              };
              _i6 = 0, _allowed = allowed;
            case 1:
              if (!(_i6 < _allowed.length)) {
                _context59.n = 4;
                break;
              }
              key = _allowed[_i6];
              if (!(fields[key] === undefined)) {
                _context59.n = 2;
                break;
              }
              return _context59.a(3, 3);
            case 2:
              sets.push("".concat(key, " = $").concat(key));
              params["$".concat(key)] = fields[key];
            case 3:
              _i6++;
              _context59.n = 1;
              break;
            case 4:
              if (sets.length) {
                _context59.n = 5;
                break;
              }
              return _context59.a(2);
            case 5:
              sets.push('updated_at = $updated_at');
              _context59.n = 6;
              return this.app.storage.runDatabase("UPDATE orders SET ".concat(sets.join(', '), " WHERE id = $id"), params, this.dbname);
            case 6:
              return _context59.a(2);
          }
        }, _callee58, this);
      }));
      function updateOrder(_x59) {
        return _updateOrder.apply(this, arguments);
      }
      return updateOrder;
    }()
  }, {
    key: "incrementOrderAttempts",
    value: function () {
      var _incrementOrderAttempts = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee59(order_id) {
        var _res$0$attempts, _res$6;
        var now,
          res,
          _args60 = arguments;
        return _regenerator().w(function (_context60) {
          while (1) switch (_context60.n) {
            case 0:
              now = _args60.length > 1 && _args60[1] !== undefined ? _args60[1] : Date.now();
              _context60.n = 1;
              return this.app.storage.runDatabase("UPDATE orders SET attempts = attempts + 1, updated_at = $updated_at WHERE id = $id", {
                $id: Number(order_id),
                $updated_at: now
              }, this.dbname);
            case 1:
              _context60.n = 2;
              return this.app.storage.queryDatabase("SELECT attempts FROM orders WHERE id = $id LIMIT 1", {
                $id: Number(order_id)
              }, this.dbname);
            case 2:
              res = _context60.v;
              return _context60.a(2, Number((_res$0$attempts = res === null || res === void 0 || (_res$6 = res[0]) === null || _res$6 === void 0 ? void 0 : _res$6.attempts) !== null && _res$0$attempts !== void 0 ? _res$0$attempts : 0));
          }
        }, _callee59, this);
      }));
      function incrementOrderAttempts(_x60) {
        return _incrementOrderAttempts.apply(this, arguments);
      }
      return incrementOrderAttempts;
    }()
    /**
     * The canonical inclusion of a purchase transaction. Prefers the longest-chain row;
     * the block_id tiebreak only matters while a reorg notification is still in flight,
     * where the newest inclusion is the one the chain is converging on.
     */
  }, {
    key: "returnOrderByTxSig",
    value: function () {
      var _returnOrderByTxSig = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee60(order_tx_sig) {
        var res;
        return _regenerator().w(function (_context61) {
          while (1) switch (_context61.n) {
            case 0:
              _context61.n = 1;
              return this.app.storage.queryDatabase("SELECT * FROM orders\n\t\t\t WHERE order_tx_sig = $order_tx_sig\n\t\t\t ORDER BY longest_chain_received DESC, block_id_received DESC, id DESC\n\t\t\t LIMIT 1", {
                $order_tx_sig: order_tx_sig
              }, this.dbname);
            case 1:
              res = _context61.v;
              return _context61.a(2, (res === null || res === void 0 ? void 0 : res[0]) || null);
          }
        }, _callee60, this);
      }));
      function returnOrderByTxSig(_x61) {
        return _returnOrderByTxSig.apply(this, arguments);
      }
      return returnOrderByTxSig;
    }()
  }, {
    key: "returnOrderBySettlementSig",
    value: function () {
      var _returnOrderBySettlementSig = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee61(settlement_tx_sig) {
        var res;
        return _regenerator().w(function (_context62) {
          while (1) switch (_context62.n) {
            case 0:
              _context62.n = 1;
              return this.app.storage.queryDatabase("SELECT * FROM orders WHERE settlement_tx_sig = $settlement_tx_sig LIMIT 1", {
                $settlement_tx_sig: settlement_tx_sig
              }, this.dbname);
            case 1:
              res = _context62.v;
              return _context62.a(2, (res === null || res === void 0 ? void 0 : res[0]) || null);
          }
        }, _callee61, this);
      }));
      function returnOrderBySettlementSig(_x62) {
        return _returnOrderBySettlementSig.apply(this, arguments);
      }
      return returnOrderBySettlementSig;
    }()
  }, {
    key: "returnListingsWithSettlementPending",
    value: function () {
      var _returnListingsWithSettlementPending = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee62() {
        var _t41;
        return _regenerator().w(function (_context63) {
          while (1) switch (_context63.p = _context63.n) {
            case 0:
              _context63.p = 0;
              _context63.n = 1;
              return this.app.storage.queryDatabase("SELECT * FROM listings\n\t\t\t\t WHERE settlement_pending = 1", {}, this.dbname);
            case 1:
              return _context63.a(2, _context63.v);
            case 2:
              _context63.p = 2;
              _t41 = _context63.v;
              return _context63.a(2, []);
          }
        }, _callee62, this, [[0, 2]]);
      }));
      function returnListingsWithSettlementPending() {
        return _returnListingsWithSettlementPending.apply(this, arguments);
      }
      return returnListingsWithSettlementPending;
    }()
  }, {
    key: "returnSettlingOrders",
    value: function () {
      var _returnSettlingOrders = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee63() {
        var _t42;
        return _regenerator().w(function (_context64) {
          while (1) switch (_context64.p = _context64.n) {
            case 0:
              _context64.p = 0;
              _context64.n = 1;
              return this.app.storage.queryDatabase(
              // An orphaned inclusion can be left in 'settling' with a settlement that can
              // never confirm. Excluding it stops it reserving its listing in
              // resetStaleSettlementPendingListings().
              "SELECT * FROM orders\n\t\t\t\t WHERE status = 'settling'\n\t\t\t\t   AND settlement_tx_sig != ''\n\t\t\t\t   AND longest_chain_received = 1", {}, this.dbname);
            case 1:
              return _context64.a(2, _context64.v);
            case 2:
              _context64.p = 2;
              _t42 = _context64.v;
              return _context64.a(2, []);
          }
        }, _callee63, this, [[0, 2]]);
      }));
      function returnSettlingOrders() {
        return _returnSettlingOrders.apply(this, arguments);
      }
      return returnSettlingOrders;
    }()
  }, {
    key: "returnPendingOrders",
    value: function () {
      var _returnPendingOrders = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee64() {
        var _t43;
        return _regenerator().w(function (_context65) {
          while (1) switch (_context65.p = _context65.n) {
            case 0:
              _context65.p = 0;
              _context65.n = 1;
              return this.app.storage.queryDatabase(
              // id ASC keeps the queue first-come-first-served across distinct purchases.
              // The NOT EXISTS clause only bites if two inclusions of one purchase are both
              // flagged longest-chain, which a reorg notification landing before the
              // confirmation insert can cause; the newer inclusion is the correct one.
              "SELECT * FROM orders\n\t\t\t\t WHERE status IN ('pending', 'settling')\n\t\t\t\t   AND longest_chain_received = 1\n\t\t\t\t   AND NOT EXISTS (\n\t\t\t\t     SELECT 1 FROM orders newer\n\t\t\t\t     WHERE newer.order_tx_sig = orders.order_tx_sig\n\t\t\t\t       AND newer.longest_chain_received = 1\n\t\t\t\t       AND (newer.block_id_received > orders.block_id_received\n\t\t\t\t            OR (newer.block_id_received = orders.block_id_received\n\t\t\t\t                AND newer.id > orders.id))\n\t\t\t\t   )\n\t\t\t\t ORDER BY id ASC", {}, this.dbname);
            case 1:
              return _context65.a(2, _context65.v);
            case 2:
              _context65.p = 2;
              _t43 = _context65.v;
              console.log('Store Database: returnPendingOrders failed', _t43 === null || _t43 === void 0 ? void 0 : _t43.message);
              return _context65.a(2, []);
          }
        }, _callee64, this, [[0, 2]]);
      }));
      function returnPendingOrders() {
        return _returnPendingOrders.apply(this, arguments);
      }
      return returnPendingOrders;
    }()
  }, {
    key: "returnOrphanedSettlingOrders",
    value: function () {
      var _returnOrphanedSettlingOrders = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee65() {
        var _t44;
        return _regenerator().w(function (_context66) {
          while (1) switch (_context66.p = _context66.n) {
            case 0:
              _context66.p = 0;
              _context66.n = 1;
              return this.app.storage.queryDatabase("SELECT * FROM orders\n\t\t\t\t WHERE status = 'settling'\n\t\t\t\t   AND longest_chain_received = 1\n\t\t\t\t   AND block_id_fulfilled > 0\n\t\t\t\t   AND longest_chain_fulfilled = 0", {}, this.dbname);
            case 1:
              return _context66.a(2, _context66.v);
            case 2:
              _context66.p = 2;
              _t44 = _context66.v;
              return _context66.a(2, []);
          }
        }, _callee65, this, [[0, 2]]);
      }));
      function returnOrphanedSettlingOrders() {
        return _returnOrphanedSettlingOrders.apply(this, arguments);
      }
      return returnOrphanedSettlingOrders;
    }()
  }, {
    key: "returnOrphanedFulfilledOrders",
    value: function () {
      var _returnOrphanedFulfilledOrders = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee66() {
        var _t45;
        return _regenerator().w(function (_context67) {
          while (1) switch (_context67.p = _context67.n) {
            case 0:
              _context67.p = 0;
              _context67.n = 1;
              return this.app.storage.queryDatabase("SELECT * FROM orders\n\t\t\t\t WHERE status = 'fulfilled'\n\t\t\t\t   AND longest_chain_received = 1\n\t\t\t\t   AND block_id_fulfilled > 0\n\t\t\t\t   AND longest_chain_fulfilled = 0", {}, this.dbname);
            case 1:
              return _context67.a(2, _context67.v);
            case 2:
              _context67.p = 2;
              _t45 = _context67.v;
              return _context67.a(2, []);
          }
        }, _callee66, this, [[0, 2]]);
      }));
      function returnOrphanedFulfilledOrders() {
        return _returnOrphanedFulfilledOrders.apply(this, arguments);
      }
      return returnOrphanedFulfilledOrders;
    }()
  }, {
    key: "updateOrdersReceivedChainState",
    value: function () {
      var _updateOrdersReceivedChainState = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee67(block_id, block_hash, longest_chain) {
        return _regenerator().w(function (_context68) {
          while (1) switch (_context68.n) {
            case 0:
              _context68.n = 1;
              return this.app.storage.runDatabase("UPDATE orders SET longest_chain_received = $longest_chain, updated_at = $updated_at\n\t\t\t WHERE block_id_received = $block_id AND block_hash_received = $block_hash", {
                $block_id: Number(block_id) || 0,
                $block_hash: String(block_hash || ''),
                $longest_chain: longest_chain ? 1 : 0,
                $updated_at: Date.now()
              }, this.dbname);
            case 1:
              return _context68.a(2);
          }
        }, _callee67, this);
      }));
      function updateOrdersReceivedChainState(_x63, _x64, _x65) {
        return _updateOrdersReceivedChainState.apply(this, arguments);
      }
      return updateOrdersReceivedChainState;
    }()
  }, {
    key: "updateOrdersFulfilledChainState",
    value: function () {
      var _updateOrdersFulfilledChainState = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee68(block_id, block_hash, longest_chain) {
        return _regenerator().w(function (_context69) {
          while (1) switch (_context69.n) {
            case 0:
              _context69.n = 1;
              return this.app.storage.runDatabase("UPDATE orders SET longest_chain_fulfilled = $longest_chain, updated_at = $updated_at\n\t\t\t WHERE block_id_fulfilled = $block_id AND block_hash_fulfilled = $block_hash", {
                $block_id: Number(block_id) || 0,
                $block_hash: String(block_hash || ''),
                $longest_chain: longest_chain ? 1 : 0,
                $updated_at: Date.now()
              }, this.dbname);
            case 1:
              return _context69.a(2);
          }
        }, _callee68, this);
      }));
      function updateOrdersFulfilledChainState(_x66, _x67, _x68) {
        return _updateOrdersFulfilledChainState.apply(this, arguments);
      }
      return updateOrdersFulfilledChainState;
    }()
  }]);
}();
module.exports = Database;